import { emptyGeneratedApi as api } from "./emptyGeneratedApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postServiceApi2BackOfficeAddDocument: build.mutation<
      PostServiceApi2BackOfficeAddDocumentApiResponse,
      PostServiceApi2BackOfficeAddDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/AddDocument`,
        method: "POST",
        params: {
          id: queryArg.id,
          name: queryArg.name,
          url: queryArg.url,
        },
      }),
    }),
    deleteServiceApi2BackOfficeRemoveDocument: build.mutation<
      DeleteServiceApi2BackOfficeRemoveDocumentApiResponse,
      DeleteServiceApi2BackOfficeRemoveDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/RemoveDocument`,
        method: "DELETE",
        params: {
          id: queryArg.id,
        },
      }),
    }),
    getServiceApi2BackOfficeGetAllIndexFeatures: build.query<
      GetServiceApi2BackOfficeGetAllIndexFeaturesApiResponse,
      GetServiceApi2BackOfficeGetAllIndexFeaturesApiArg
    >({
      query: () => ({ url: `/service/api2/BackOffice/GetAllIndexFeatures` }),
    }),
    getServiceApi2BackOfficeGetAllFeatures: build.query<
      GetServiceApi2BackOfficeGetAllFeaturesApiResponse,
      GetServiceApi2BackOfficeGetAllFeaturesApiArg
    >({
      query: () => ({ url: `/service/api2/BackOffice/GetAllFeatures` }),
    }),
    putServiceApi2BackOfficeAddFeatureToIndex: build.mutation<
      PutServiceApi2BackOfficeAddFeatureToIndexApiResponse,
      PutServiceApi2BackOfficeAddFeatureToIndexApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/AddFeatureToIndex`,
        method: "PUT",
        params: {
          feature: queryArg.feature,
          index: queryArg.index,
        },
      }),
    }),
    deleteServiceApi2BackOfficeRemoveFeatureFromIndex: build.mutation<
      DeleteServiceApi2BackOfficeRemoveFeatureFromIndexApiResponse,
      DeleteServiceApi2BackOfficeRemoveFeatureFromIndexApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/RemoveFeatureFromIndex`,
        method: "DELETE",
        params: {
          feature: queryArg.feature,
          index: queryArg.index,
        },
      }),
    }),
    getServiceApi2BackOfficeGetAllIndexes: build.query<
      GetServiceApi2BackOfficeGetAllIndexesApiResponse,
      GetServiceApi2BackOfficeGetAllIndexesApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/GetAllIndexes`,
        params: {
          searchTerm: queryArg.searchTerm,
        },
      }),
    }),
    postServiceApi2BackOfficeAddIndex: build.mutation<
      PostServiceApi2BackOfficeAddIndexApiResponse,
      PostServiceApi2BackOfficeAddIndexApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/AddIndex`,
        method: "POST",
        params: {
          name: queryArg.name,
          dataCutOffDate: queryArg.dataCutOffDate,
        },
      }),
    }),
    putServiceApi2BackOfficeUpdateIndexById: build.mutation<
      PutServiceApi2BackOfficeUpdateIndexByIdApiResponse,
      PutServiceApi2BackOfficeUpdateIndexByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/UpdateIndex/${queryArg.id}`,
        method: "PUT",
        params: {
          name: queryArg.name,
          dataCutOffDate: queryArg.dataCutOffDate,
        },
      }),
    }),
    getServiceApi2BackOfficeGetInstitutionsPageByNameAndId: build.query<
      GetServiceApi2BackOfficeGetInstitutionsPageByNameAndIdApiResponse,
      GetServiceApi2BackOfficeGetInstitutionsPageByNameAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/GetInstitutionsPageByNameAndId`,
        params: {
          After: queryArg.after,
          Before: queryArg.before,
          PageSize: queryArg.pageSize,
          SortDirection: queryArg.sortDirection,
          OrderBy: queryArg.orderBy,
          PageIndex: queryArg.pageIndex,
          searchTerm: queryArg.searchTerm,
        },
      }),
    }),
    getServiceApi2BackOfficeGetAllInstitutions: build.query<
      GetServiceApi2BackOfficeGetAllInstitutionsApiResponse,
      GetServiceApi2BackOfficeGetAllInstitutionsApiArg
    >({
      query: () => ({ url: `/service/api2/BackOffice/GetAllInstitutions` }),
    }),
    postServiceApi2BackOfficeCreateInstitution: build.mutation<
      PostServiceApi2BackOfficeCreateInstitutionApiResponse,
      PostServiceApi2BackOfficeCreateInstitutionApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/CreateInstitution`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putServiceApi2BackOfficeUpdateInstitution: build.mutation<
      PutServiceApi2BackOfficeUpdateInstitutionApiResponse,
      PutServiceApi2BackOfficeUpdateInstitutionApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/UpdateInstitution`,
        method: "PUT",
        body: queryArg.body,
        params: {
          id: queryArg.id,
        },
      }),
    }),
    deleteServiceApi2BackOfficeDeleteInstitution: build.mutation<
      DeleteServiceApi2BackOfficeDeleteInstitutionApiResponse,
      DeleteServiceApi2BackOfficeDeleteInstitutionApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/DeleteInstitution`,
        method: "DELETE",
        params: {
          id: queryArg.id,
        },
      }),
    }),
    getServiceApi2BackOfficeGetInstitutionsBySubscription: build.query<
      GetServiceApi2BackOfficeGetInstitutionsBySubscriptionApiResponse,
      GetServiceApi2BackOfficeGetInstitutionsBySubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/GetInstitutionsBySubscription`,
        params: {
          subscriptionId: queryArg.subscriptionId,
        },
      }),
    }),
    postServiceApi2BackOfficeAddPermission: build.mutation<
      PostServiceApi2BackOfficeAddPermissionApiResponse,
      PostServiceApi2BackOfficeAddPermissionApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/AddPermission`,
        method: "POST",
        params: {
          subscriptionId: queryArg.subscriptionId,
          feature: queryArg.feature,
          index: queryArg.index,
        },
      }),
    }),
    deleteServiceApi2BackOfficeRemovePermissionBySubscriptionId: build.mutation<
      DeleteServiceApi2BackOfficeRemovePermissionBySubscriptionIdApiResponse,
      DeleteServiceApi2BackOfficeRemovePermissionBySubscriptionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/RemovePermission/${queryArg.subscriptionId}`,
        method: "DELETE",
        params: {
          feature: queryArg.feature,
          index: queryArg.index,
        },
      }),
    }),
    getServiceApi2BackOfficeGetSubscriptions: build.query<
      GetServiceApi2BackOfficeGetSubscriptionsApiResponse,
      GetServiceApi2BackOfficeGetSubscriptionsApiArg
    >({
      query: () => ({ url: `/service/api2/BackOffice/GetSubscriptions` }),
    }),
    postServiceApi2BackOfficeCreateSubscription: build.mutation<
      PostServiceApi2BackOfficeCreateSubscriptionApiResponse,
      PostServiceApi2BackOfficeCreateSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/CreateSubscription`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putServiceApi2BackOfficeUpdateSubscription: build.mutation<
      PutServiceApi2BackOfficeUpdateSubscriptionApiResponse,
      PutServiceApi2BackOfficeUpdateSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/UpdateSubscription`,
        method: "PUT",
        body: queryArg.body,
        params: {
          id: queryArg.id,
        },
      }),
    }),
    deleteServiceApi2BackOfficeDeleteSubscription: build.mutation<
      DeleteServiceApi2BackOfficeDeleteSubscriptionApiResponse,
      DeleteServiceApi2BackOfficeDeleteSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/DeleteSubscription`,
        method: "DELETE",
        params: {
          id: queryArg.id,
        },
      }),
    }),
    getServiceApi2BackOfficeGetUnassignedUsers: build.query<
      GetServiceApi2BackOfficeGetUnassignedUsersApiResponse,
      GetServiceApi2BackOfficeGetUnassignedUsersApiArg
    >({
      query: () => ({ url: `/service/api2/BackOffice/GetUnassignedUsers` }),
    }),
    getServiceApi2BackOfficeGetUsersByInstitution: build.query<
      GetServiceApi2BackOfficeGetUsersByInstitutionApiResponse,
      GetServiceApi2BackOfficeGetUsersByInstitutionApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/GetUsersByInstitution`,
        params: {
          institutionId: queryArg.institutionId,
        },
      }),
    }),
    putServiceApi2BackOfficeAssignUserToInstitution: build.mutation<
      PutServiceApi2BackOfficeAssignUserToInstitutionApiResponse,
      PutServiceApi2BackOfficeAssignUserToInstitutionApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/AssignUserToInstitution`,
        method: "PUT",
        params: {
          userId: queryArg.userId,
          institutionId: queryArg.institutionId,
        },
      }),
    }),
    postServiceApi2BackOfficeCreateUser: build.mutation<
      PostServiceApi2BackOfficeCreateUserApiResponse,
      PostServiceApi2BackOfficeCreateUserApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/CreateUser`,
        method: "POST",
        params: {
          displayName: queryArg.displayName,
          emailAddress: queryArg.emailAddress,
          canViewInstitutionValuations: queryArg.canViewInstitutionValuations,
          isInstitutionAdmin: queryArg.isInstitutionAdmin,
        },
      }),
    }),
    postServiceApi2BackOfficeCreateUserWithInstitution: build.mutation<
      PostServiceApi2BackOfficeCreateUserWithInstitutionApiResponse,
      PostServiceApi2BackOfficeCreateUserWithInstitutionApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/CreateUserWithInstitution`,
        method: "POST",
        params: {
          displayName: queryArg.displayName,
          emailAddress: queryArg.emailAddress,
          institutionId: queryArg.institutionId,
          canViewInstitutionValuations: queryArg.canViewInstitutionValuations,
          isInstitutionAdmin: queryArg.isInstitutionAdmin,
        },
      }),
    }),
    deleteServiceApi2BackOfficeDeleteUser: build.mutation<
      DeleteServiceApi2BackOfficeDeleteUserApiResponse,
      DeleteServiceApi2BackOfficeDeleteUserApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/DeleteUser`,
        method: "DELETE",
        params: {
          id: queryArg.id,
        },
      }),
    }),
    putServiceApi2BackOfficeUpdateUser: build.mutation<
      PutServiceApi2BackOfficeUpdateUserApiResponse,
      PutServiceApi2BackOfficeUpdateUserApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/UpdateUser`,
        method: "PUT",
        params: {
          id: queryArg.id,
          canViewInstitutionValuations: queryArg.canViewInstitutionValuations,
          isInstitutionAdmin: queryArg.isInstitutionAdmin,
        },
      }),
    }),
    postServiceApiBackOfficeSendInvitation: build.mutation<
      PostServiceApiBackOfficeSendInvitationApiResponse,
      PostServiceApiBackOfficeSendInvitationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/BackOffice/SendInvitation`,
        method: "POST",
        params: {
          id: queryArg.id,
        },
      }),
    }),
    getServiceApi2BackOfficeEncrypt: build.query<
      GetServiceApi2BackOfficeEncryptApiResponse,
      GetServiceApi2BackOfficeEncryptApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/Encrypt`,
        params: {
          clearText: queryArg.clearText,
        },
      }),
    }),
    getServiceApi2BackOfficeDecrypt: build.query<
      GetServiceApi2BackOfficeDecryptApiResponse,
      GetServiceApi2BackOfficeDecryptApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/Decrypt`,
        params: {
          encryptedText: queryArg.encryptedText,
        },
      }),
    }),
    postServiceApi2BackOfficeValuationReportReloadAssets: build.mutation<
      PostServiceApi2BackOfficeValuationReportReloadAssetsApiResponse,
      PostServiceApi2BackOfficeValuationReportReloadAssetsApiArg
    >({
      query: () => ({
        url: `/service/api2/BackOffice/ValuationReport/ReloadAssets`,
        method: "POST",
      }),
    }),
    deleteServiceApi2BackOfficeRemoveWidgetById: build.mutation<
      DeleteServiceApi2BackOfficeRemoveWidgetByIdApiResponse,
      DeleteServiceApi2BackOfficeRemoveWidgetByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api2/BackOffice/RemoveWidget/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    postServiceApiBatchesBatch: build.mutation<
      PostServiceApiBatchesBatchApiResponse,
      PostServiceApiBatchesBatchApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/batches/Batch`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postServiceApiBatchesByUuidProcessed: build.mutation<
      PostServiceApiBatchesByUuidProcessedApiResponse,
      PostServiceApiBatchesByUuidProcessedApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/batches/${queryArg.uuid}/processed`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getServiceApiBatchesStatus: build.query<
      GetServiceApiBatchesStatusApiResponse,
      GetServiceApiBatchesStatusApiArg
    >({
      query: () => ({ url: `/service/api/batches/Status` }),
    }),
    getServiceApiBatchesResult: build.query<
      GetServiceApiBatchesResultApiResponse,
      GetServiceApiBatchesResultApiArg
    >({
      query: () => ({ url: `/service/api/batches/Result` }),
    }),
    getServiceApiPing: build.query<
      GetServiceApiPingApiResponse,
      GetServiceApiPingApiArg
    >({
      query: () => ({ url: `/service/api/ping` }),
    }),
    headServiceApiPing: build.mutation<
      HeadServiceApiPingApiResponse,
      HeadServiceApiPingApiArg
    >({
      query: () => ({ url: `/service/api/ping`, method: "HEAD" }),
    }),
    postServiceApiIndexIpivaluation: build.mutation<
      PostServiceApiIndexIpivaluationApiResponse,
      PostServiceApiIndexIpivaluationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/index/ipivaluation`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postServiceApiIndexIpirent: build.mutation<
      PostServiceApiIndexIpirentApiResponse,
      PostServiceApiIndexIpirentApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/index/ipirent`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postServiceApiIndexSim: build.mutation<
      PostServiceApiIndexSimApiResponse,
      PostServiceApiIndexSimApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/index/sim`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postServiceApiIndexSipn: build.mutation<
      PostServiceApiIndexSipnApiResponse,
      PostServiceApiIndexSipnApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/index/sipn`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postServiceApiIndexSepi: build.mutation<
      PostServiceApiIndexSepiApiResponse,
      PostServiceApiIndexSepiApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/index/sepi`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postServiceApiIndexValuationAipi: build.mutation<
      PostServiceApiIndexValuationAipiApiResponse,
      PostServiceApiIndexValuationAipiApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/index/valuation-aipi`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postServiceApiIndexDemandscore: build.mutation<
      PostServiceApiIndexDemandscoreApiResponse,
      PostServiceApiIndexDemandscoreApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/index/demandscore`,
        method: "POST",
        body: queryArg.body,
        params: {
          type: queryArg["type"],
        },
      }),
    }),
    postServiceApiIndexCrr3RiskDiscount: build.mutation<
      PostServiceApiIndexCrr3RiskDiscountApiResponse,
      PostServiceApiIndexCrr3RiskDiscountApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/index/crr3-risk-discount`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getServiceApiIndexByIndexDocument: build.query<
      GetServiceApiIndexByIndexDocumentApiResponse,
      GetServiceApiIndexByIndexDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/index/${queryArg.index}/document`,
        params: {
          documentType: queryArg.documentType,
        },
      }),
    }),
    getServiceApiInstitutionUsers: build.query<
      GetServiceApiInstitutionUsersApiResponse,
      GetServiceApiInstitutionUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/institution/Users`,
        params: {
          After: queryArg.after,
          Before: queryArg.before,
          PageSize: queryArg.pageSize,
          SortDirection: queryArg.sortDirection,
          OrderBy: queryArg.orderBy,
          PageIndex: queryArg.pageIndex,
          SearchTerm: queryArg.searchTerm,
          Role: queryArg.role,
        },
      }),
    }),
    putServiceApiInstitutionProfileSettings: build.mutation<
      PutServiceApiInstitutionProfileSettingsApiResponse,
      PutServiceApiInstitutionProfileSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/institution/profile_settings`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getServiceApiInstitutionProfileSettings: build.query<
      GetServiceApiInstitutionProfileSettingsApiResponse,
      GetServiceApiInstitutionProfileSettingsApiArg
    >({
      query: () => ({ url: `/service/api/institution/profile_settings` }),
    }),
    postServiceApiInstitutionCreateUser: build.mutation<
      PostServiceApiInstitutionCreateUserApiResponse,
      PostServiceApiInstitutionCreateUserApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/institution/CreateUser`,
        method: "POST",
        params: {
          displayName: queryArg.displayName,
          emailAddress: queryArg.emailAddress,
          canViewInstitutionValuations: queryArg.canViewInstitutionValuations,
          isInstitutionAdmin: queryArg.isInstitutionAdmin,
        },
      }),
    }),
    deleteServiceApiInstitutionDeleteUser: build.mutation<
      DeleteServiceApiInstitutionDeleteUserApiResponse,
      DeleteServiceApiInstitutionDeleteUserApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/institution/DeleteUser`,
        method: "DELETE",
        params: {
          id: queryArg.id,
        },
      }),
    }),
    putServiceApiInstitutionUpdateUser: build.mutation<
      PutServiceApiInstitutionUpdateUserApiResponse,
      PutServiceApiInstitutionUpdateUserApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/institution/UpdateUser`,
        method: "PUT",
        params: {
          id: queryArg.id,
          canViewInstitutionValuations: queryArg.canViewInstitutionValuations,
          isInstitutionAdmin: queryArg.isInstitutionAdmin,
        },
      }),
    }),
    getServiceApiOktaHook: build.query<
      GetServiceApiOktaHookApiResponse,
      GetServiceApiOktaHookApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/OktaHook`,
        headers: {
          "X-Okta-Verification-Challenge":
            queryArg["X-Okta-Verification-Challenge"],
        },
      }),
    }),
    postServiceApiOktaHook: build.mutation<
      PostServiceApiOktaHookApiResponse,
      PostServiceApiOktaHookApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/OktaHook`,
        method: "POST",
        headers: {
          "X-Okta-Secret-Challenge": queryArg["X-Okta-Secret-Challenge"],
        },
      }),
    }),
    postServiceApiOktaHookPermissions: build.mutation<
      PostServiceApiOktaHookPermissionsApiResponse,
      PostServiceApiOktaHookPermissionsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/OktaHook/permissions`,
        method: "POST",
        headers: {
          "X-Okta-Secret-Challenge": queryArg["X-Okta-Secret-Challenge"],
        },
      }),
    }),
    postServiceApiV2OneclickSone: build.mutation<
      PostServiceApiV2OneclickSoneApiResponse,
      PostServiceApiV2OneclickSoneApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/v2/oneclick/sone`,
        method: "POST",
        body: queryArg.body,
        params: {
          orderType: queryArg.orderType,
        },
      }),
    }),
    postServiceApiV2OneclickObjectPlatform: build.mutation<
      PostServiceApiV2OneclickObjectPlatformApiResponse,
      PostServiceApiV2OneclickObjectPlatformApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/v2/oneclick/object_platform`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postServiceApiOutlierShieldPlausibilityCheckBySoneValuationId:
      build.mutation<
        PostServiceApiOutlierShieldPlausibilityCheckBySoneValuationIdApiResponse,
        PostServiceApiOutlierShieldPlausibilityCheckBySoneValuationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/service/api/outlier_shield/plausibility_check/${queryArg.soneValuationId}`,
          method: "POST",
        }),
      }),
    postServiceApiOutlierShieldGetPlausibilityCheckRequestBody: build.mutation<
      PostServiceApiOutlierShieldGetPlausibilityCheckRequestBodyApiResponse,
      PostServiceApiOutlierShieldGetPlausibilityCheckRequestBodyApiArg
    >({
      query: () => ({
        url: `/service/api/outlier_shield/get_plausibility_check_request_body`,
        method: "POST",
      }),
    }),
    getServiceApiProtocolDataInstitutions: build.query<
      GetServiceApiProtocolDataInstitutionsApiResponse,
      GetServiceApiProtocolDataInstitutionsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/protocol_data/institutions`,
        params: {
          After: queryArg.after,
          Before: queryArg.before,
          PageSize: queryArg.pageSize,
          SortDirection: queryArg.sortDirection,
          OrderBy: queryArg.orderBy,
          PageIndex: queryArg.pageIndex,
        },
      }),
    }),
    getServiceApiShopProducts: build.query<
      GetServiceApiShopProductsApiResponse,
      GetServiceApiShopProductsApiArg
    >({
      query: () => ({ url: `/service/api/shop/products` }),
    }),
    postServiceApiShopPurchasesByProductId: build.mutation<
      PostServiceApiShopPurchasesByProductIdApiResponse,
      PostServiceApiShopPurchasesByProductIdApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/shop/purchases/${queryArg.productId}`,
        method: "POST",
      }),
    }),
    postExchange: build.mutation<PostExchangeApiResponse, PostExchangeApiArg>({
      query: (queryArg) => ({
        url: `/exchange`,
        method: "POST",
        headers: {
          Origin: queryArg.origin,
        },
        params: {
          token: queryArg.token,
          id: queryArg.id,
        },
      }),
    }),
    getServiceApiUserPermissions: build.query<
      GetServiceApiUserPermissionsApiResponse,
      GetServiceApiUserPermissionsApiArg
    >({
      query: () => ({ url: `/service/api/user/permissions` }),
    }),
    putServiceApiUserProfileSettings: build.mutation<
      PutServiceApiUserProfileSettingsApiResponse,
      PutServiceApiUserProfileSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/user/profile_settings`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getServiceApiUserProfileSettings: build.query<
      GetServiceApiUserProfileSettingsApiResponse,
      GetServiceApiUserProfileSettingsApiArg
    >({
      query: () => ({ url: `/service/api/user/profile_settings` }),
    }),
    getServiceApiUserProfile: build.query<
      GetServiceApiUserProfileApiResponse,
      GetServiceApiUserProfileApiArg
    >({
      query: () => ({ url: `/service/api/user/profile` }),
    }),
    getServiceApiValuationPackageStatus: build.query<
      GetServiceApiValuationPackageStatusApiResponse,
      GetServiceApiValuationPackageStatusApiArg
    >({
      query: () => ({ url: `/service/api/valuation_package/status` }),
    }),
    getServiceApiValuationPackageInstitutionReports: build.query<
      GetServiceApiValuationPackageInstitutionReportsApiResponse,
      GetServiceApiValuationPackageInstitutionReportsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_package/institution/reports`,
        params: {
          generated_at_from: queryArg.generatedAtFrom,
          generated_at_to: queryArg.generatedAtTo,
        },
      }),
    }),
    getServiceApiValuationPackageValuations: build.query<
      GetServiceApiValuationPackageValuationsApiResponse,
      GetServiceApiValuationPackageValuationsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_package/valuations`,
        params: {
          After: queryArg.after,
          Before: queryArg.before,
          PageSize: queryArg.pageSize,
          SortDirection: queryArg.sortDirection,
          OrderBy: queryArg.orderBy,
          PageIndex: queryArg.pageIndex,
          ShowOnlyMine: queryArg.showOnlyMine,
          AddressSearchQuery: queryArg.addressSearchQuery,
          Nation: queryArg.nation,
          Town: queryArg.town,
          Street: queryArg.street,
          HouseNumber: queryArg.houseNumber,
          PostCode: queryArg.postCode,
          CreateAtBefore: queryArg.createAtBefore,
          CreateAtAfter: queryArg.createAtAfter,
          BuildingType: queryArg.buildingType,
        },
      }),
    }),
    postServiceApiValuationPackageValuation: build.mutation<
      PostServiceApiValuationPackageValuationApiResponse,
      PostServiceApiValuationPackageValuationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_package/valuation`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postServiceApiValuationPackageValuationPartner: build.mutation<
      PostServiceApiValuationPackageValuationPartnerApiResponse,
      PostServiceApiValuationPackageValuationPartnerApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_package/valuation-partner`,
        method: "POST",
        body: queryArg.body,
        params: {
          pid: queryArg.pid,
        },
      }),
    }),
    putServiceApiValuationPackageValuationByItemId: build.mutation<
      PutServiceApiValuationPackageValuationByItemIdApiResponse,
      PutServiceApiValuationPackageValuationByItemIdApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_package/valuation/${queryArg.itemId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getServiceApiValuationPackageValuationByItemId: build.query<
      GetServiceApiValuationPackageValuationByItemIdApiResponse,
      GetServiceApiValuationPackageValuationByItemIdApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_package/valuation/${queryArg.itemId}`,
      }),
    }),
    deleteServiceApiValuationPackageValuationByItemId: build.mutation<
      DeleteServiceApiValuationPackageValuationByItemIdApiResponse,
      DeleteServiceApiValuationPackageValuationByItemIdApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_package/valuation/${queryArg.itemId}`,
        method: "DELETE",
      }),
    }),
    postServiceApiValuationPackageValuationByItemIdCopy: build.mutation<
      PostServiceApiValuationPackageValuationByItemIdCopyApiResponse,
      PostServiceApiValuationPackageValuationByItemIdCopyApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_package/valuation/${queryArg.itemId}/copy`,
        method: "POST",
      }),
    }),
    postServiceApiValuationPackageValuationByItemIdValuate: build.mutation<
      PostServiceApiValuationPackageValuationByItemIdValuateApiResponse,
      PostServiceApiValuationPackageValuationByItemIdValuateApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_package/valuation/${queryArg.itemId}/valuate`,
        method: "POST",
        params: {
          valuationType: queryArg.valuationType,
        },
      }),
    }),
    postServiceApiValuationPackageValuationPartnervaluate: build.mutation<
      PostServiceApiValuationPackageValuationPartnervaluateApiResponse,
      PostServiceApiValuationPackageValuationPartnervaluateApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_package/valuation/partnervaluate`,
        method: "POST",
        params: {
          propertyId: queryArg.propertyId,
          institutionId: queryArg.institutionId,
          valuationType: queryArg.valuationType,
        },
      }),
    }),
    postServiceApiValuationPackageValuationByItemIdReportPdf: build.mutation<
      PostServiceApiValuationPackageValuationByItemIdReportPdfApiResponse,
      PostServiceApiValuationPackageValuationByItemIdReportPdfApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_package/valuation/${queryArg.itemId}/report/pdf`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getServiceApiValuationPackageValuationByItemIdReportPdf: build.query<
      GetServiceApiValuationPackageValuationByItemIdReportPdfApiResponse,
      GetServiceApiValuationPackageValuationByItemIdReportPdfApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_package/valuation/${queryArg.itemId}/report/pdf`,
      }),
    }),
    postServiceApiValuationPackageValuationByItemIdReportDocx: build.mutation<
      PostServiceApiValuationPackageValuationByItemIdReportDocxApiResponse,
      PostServiceApiValuationPackageValuationByItemIdReportDocxApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_package/valuation/${queryArg.itemId}/report/docx`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getServiceApiValuationPackageValuationByItemIdReportDocx: build.query<
      GetServiceApiValuationPackageValuationByItemIdReportDocxApiResponse,
      GetServiceApiValuationPackageValuationByItemIdReportDocxApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_package/valuation/${queryArg.itemId}/report/docx`,
      }),
    }),
    postServiceApiValuationPackageValuationByValuationPackageItemIdImage:
      build.mutation<
        PostServiceApiValuationPackageValuationByValuationPackageItemIdImageApiResponse,
        PostServiceApiValuationPackageValuationByValuationPackageItemIdImageApiArg
      >({
        query: (queryArg) => ({
          url: `/service/api/valuation_package/valuation/${queryArg.valuationPackageItemId}/image`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postServiceApiValuationPackageValuationPartnerByValuationPackageItemIdImages:
      build.mutation<
        PostServiceApiValuationPackageValuationPartnerByValuationPackageItemIdImagesApiResponse,
        PostServiceApiValuationPackageValuationPartnerByValuationPackageItemIdImagesApiArg
      >({
        query: (queryArg) => ({
          url: `/service/api/valuation_package/valuation-partner/${queryArg.valuationPackageItemId}/images`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    deleteServiceApiValuationPackageValuationImageById: build.mutation<
      DeleteServiceApiValuationPackageValuationImageByIdApiResponse,
      DeleteServiceApiValuationPackageValuationImageByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_package/valuation/image/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getServiceApiValuationPackageValuationByValuationPackageItemIdImages:
      build.query<
        GetServiceApiValuationPackageValuationByValuationPackageItemIdImagesApiResponse,
        GetServiceApiValuationPackageValuationByValuationPackageItemIdImagesApiArg
      >({
        query: (queryArg) => ({
          url: `/service/api/valuation_package/valuation/${queryArg.valuationPackageItemId}/images`,
        }),
      }),
    putServiceApiValuationPackageValuationByValuationPackageItemIdImages:
      build.mutation<
        PutServiceApiValuationPackageValuationByValuationPackageItemIdImagesApiResponse,
        PutServiceApiValuationPackageValuationByValuationPackageItemIdImagesApiArg
      >({
        query: (queryArg) => ({
          url: `/service/api/valuation_package/valuation/${queryArg.valuationPackageItemId}/images`,
          method: "PUT",
          body: queryArg.body,
        }),
      }),
    getServiceApiValuationReportLogin: build.query<
      GetServiceApiValuationReportLoginApiResponse,
      GetServiceApiValuationReportLoginApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_report/login`,
        params: {
          realEstateId: queryArg.realEstateId,
          provider: queryArg.provider,
        },
      }),
    }),
    getServiceApiValuationReportLoginCallbackByRealEstateId: build.query<
      GetServiceApiValuationReportLoginCallbackByRealEstateIdApiResponse,
      GetServiceApiValuationReportLoginCallbackByRealEstateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_report/login/callback/${queryArg.realEstateId}`,
        params: {
          oauth_token: queryArg.oauthToken,
          oauth_verifier: queryArg.oauthVerifier,
          provider: queryArg.provider,
          state: queryArg.state,
        },
      }),
    }),
    getServiceApiValuationReportStatus: build.query<
      GetServiceApiValuationReportStatusApiResponse,
      GetServiceApiValuationReportStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_report/status`,
        headers: {
          "X-Session-Token": queryArg["X-Session-Token"],
        },
      }),
    }),
    getServiceApiValuationReportRealEstate: build.query<
      GetServiceApiValuationReportRealEstateApiResponse,
      GetServiceApiValuationReportRealEstateApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_report/real_estate`,
        headers: {
          "X-Session-Token": queryArg["X-Session-Token"],
        },
      }),
    }),
    putServiceApiValuationReportRealEstate: build.mutation<
      PutServiceApiValuationReportRealEstateApiResponse,
      PutServiceApiValuationReportRealEstateApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_report/real_estate`,
        method: "PUT",
        body: queryArg.body,
        headers: {
          "X-Session-Token": queryArg["X-Session-Token"],
        },
      }),
    }),
    getServiceApiValuationReportRealEstateImages: build.query<
      GetServiceApiValuationReportRealEstateImagesApiResponse,
      GetServiceApiValuationReportRealEstateImagesApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_report/real_estate/images`,
        headers: {
          "X-Session-Token": queryArg["X-Session-Token"],
        },
      }),
    }),
    getServiceApiValuationReportRealEstateContact: build.query<
      GetServiceApiValuationReportRealEstateContactApiResponse,
      GetServiceApiValuationReportRealEstateContactApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_report/real_estate/contact`,
        headers: {
          "X-Session-Token": queryArg["X-Session-Token"],
        },
      }),
    }),
    getServiceApiValuationReportAvmValuate: build.query<
      GetServiceApiValuationReportAvmValuateApiResponse,
      GetServiceApiValuationReportAvmValuateApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_report/avm/valuate`,
        headers: {
          "X-Session-Token": queryArg["X-Session-Token"],
        },
      }),
    }),
    getServiceApiValuationReportSoneValuate: build.query<
      GetServiceApiValuationReportSoneValuateApiResponse,
      GetServiceApiValuationReportSoneValuateApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_report/sone/valuate`,
        headers: {
          "X-Session-Token": queryArg["X-Session-Token"],
        },
      }),
    }),
    getServiceApiValuationReportProsawebValuate: build.query<
      GetServiceApiValuationReportProsawebValuateApiResponse,
      GetServiceApiValuationReportProsawebValuateApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_report/prosaweb/valuate`,
        headers: {
          "X-Session-Token": queryArg["X-Session-Token"],
        },
      }),
    }),
    postServiceApiValuationReportReport: build.mutation<
      PostServiceApiValuationReportReportApiResponse,
      PostServiceApiValuationReportReportApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_report/report`,
        method: "POST",
        body: queryArg.body,
        headers: {
          "X-Session-Token": queryArg["X-Session-Token"],
        },
      }),
    }),
    getServiceApiValuationReportReport: build.query<
      GetServiceApiValuationReportReportApiResponse,
      GetServiceApiValuationReportReportApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/valuation_report/report`,
        headers: {
          "X-Session-Token": queryArg["X-Session-Token"],
        },
      }),
    }),
    postServiceApiSim: build.mutation<
      PostServiceApiSimApiResponse,
      PostServiceApiSimApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/sim`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postServiceApiSipn: build.mutation<
      PostServiceApiSipnApiResponse,
      PostServiceApiSipnApiArg
    >({
      query: (queryArg) => ({
        url: `/service/api/sipn`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type PostServiceApi2BackOfficeAddDocumentApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelFeature;
export type PostServiceApi2BackOfficeAddDocumentApiArg = {
  /** Index Id. */
  id?: number;
  /** Document name. */
  name?: string;
  /** Document URL */
  url?: string;
};
export type DeleteServiceApi2BackOfficeRemoveDocumentApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelDocument;
export type DeleteServiceApi2BackOfficeRemoveDocumentApiArg = {
  /** Document Id. */
  id?: number;
};
export type GetServiceApi2BackOfficeGetAllIndexFeaturesApiResponse =
  /** status 200 OK */ AzureResponse601SystemCollectionsGenericList601SprengnetterSprengConnectApiDtoResponsesIndexFeaturesDtoRead;
export type GetServiceApi2BackOfficeGetAllIndexFeaturesApiArg = void;
export type GetServiceApi2BackOfficeGetAllFeaturesApiResponse =
  /** status 200 OK */ AzureResponse601SystemCollectionsGenericList601ValuationHubCoreModelFeatureRead;
export type GetServiceApi2BackOfficeGetAllFeaturesApiArg = void;
export type PutServiceApi2BackOfficeAddFeatureToIndexApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelFeature;
export type PutServiceApi2BackOfficeAddFeatureToIndexApiArg = {
  /** Feature to add. */
  feature?: ValuationHubCoreModelFeatureType;
  /** Index. */
  index?: ValuationHubCoreModelIndexType;
};
export type DeleteServiceApi2BackOfficeRemoveFeatureFromIndexApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelFeature;
export type DeleteServiceApi2BackOfficeRemoveFeatureFromIndexApiArg = {
  /** Feature to remove from Index. */
  feature?: ValuationHubCoreModelFeatureType;
  /** Index to remove Feature from. */
  index?: ValuationHubCoreModelIndexType;
};
export type GetServiceApi2BackOfficeGetAllIndexesApiResponse =
  /** status 200 OK */ SprengnetterSprengConnectApiDtoResponsesIndexDto[];
export type GetServiceApi2BackOfficeGetAllIndexesApiArg = {
  /** Search term. */
  searchTerm?: string;
};
export type PostServiceApi2BackOfficeAddIndexApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelIndex;
export type PostServiceApi2BackOfficeAddIndexApiArg = {
  /** Name of the Index. */
  name?: string;
  /** Date of data cut-off. */
  dataCutOffDate?: string;
};
export type PutServiceApi2BackOfficeUpdateIndexByIdApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelIndex;
export type PutServiceApi2BackOfficeUpdateIndexByIdApiArg = {
  /** Id of the Index to update. */
  id: number;
  /** New name of the Index. */
  name?: string;
  /** Date of Data cut off. */
  dataCutOffDate?: string;
};
export type GetServiceApi2BackOfficeGetInstitutionsPageByNameAndIdApiResponse =
  /** status 200 OK */ SprengnetterSprengConnectApiDtoResponsesInstitutionsResponse;
export type GetServiceApi2BackOfficeGetInstitutionsPageByNameAndIdApiArg = {
  after?: string;
  before?: string;
  pageSize?: number;
  sortDirection?: "Ascending" | "Descending";
  orderBy?: string;
  pageIndex?: number;
  /** Search term. */
  searchTerm?: string;
};
export type GetServiceApi2BackOfficeGetAllInstitutionsApiResponse =
  /** status 200 OK */ SprengnetterSprengConnectApiDtoResponsesInstitutionShortDto[];
export type GetServiceApi2BackOfficeGetAllInstitutionsApiArg = void;
export type PostServiceApi2BackOfficeCreateInstitutionApiResponse =
  /** status 200 OK */ ValuationHubCoreModelInstitutionRead;
export type PostServiceApi2BackOfficeCreateInstitutionApiArg = {
  /** Request with inputs to create institution */
  body: ValuationHubCoreModelDtoInstitutionDto;
};
export type PutServiceApi2BackOfficeUpdateInstitutionApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601SprengnetterSprengConnectApiDtoResponsesInstitutionDto;
export type PutServiceApi2BackOfficeUpdateInstitutionApiArg = {
  /** Id of the Institution to update. */
  id?: number;
  /** Request with inputs to update Institution. */
  body: ValuationHubCoreModelDtoInstitutionDto;
};
export type DeleteServiceApi2BackOfficeDeleteInstitutionApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelInstitutionRead;
export type DeleteServiceApi2BackOfficeDeleteInstitutionApiArg = {
  /** Id of Institution to delete. */
  id?: number;
};
export type GetServiceApi2BackOfficeGetInstitutionsBySubscriptionApiResponse =
  /** status 200 OK */ AzureResponse601SystemCollectionsGenericList601SprengnetterSprengConnectApiDtoResponsesAssignedInstitutionsToSubscriptionDtoRead;
export type GetServiceApi2BackOfficeGetInstitutionsBySubscriptionApiArg = {
  /** Id of the Subscription. */
  subscriptionId?: number;
};
export type PostServiceApi2BackOfficeAddPermissionApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelPermission;
export type PostServiceApi2BackOfficeAddPermissionApiArg = {
  /** Subscription Id. */
  subscriptionId?: number;
  /** Feature of the Permission to add. */
  feature?: ValuationHubCoreModelFeatureType;
  /** Index of the Permission to add. */
  index?: ValuationHubCoreModelIndexType;
};
export type DeleteServiceApi2BackOfficeRemovePermissionBySubscriptionIdApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelPermission;
export type DeleteServiceApi2BackOfficeRemovePermissionBySubscriptionIdApiArg =
  {
    /** Subscription Id. */
    subscriptionId: number;
    /** Feature of the Permission to remove. */
    feature?: ValuationHubCoreModelFeatureType;
    /** Index of the Permission to remove. */
    index?: ValuationHubCoreModelIndexType;
  };
export type GetServiceApi2BackOfficeGetSubscriptionsApiResponse =
  /** status 200 OK */ ValuationHubCoreModelSubscription[];
export type GetServiceApi2BackOfficeGetSubscriptionsApiArg = void;
export type PostServiceApi2BackOfficeCreateSubscriptionApiResponse =
  /** status 200 OK */ ValuationHubCoreModelSubscription;
export type PostServiceApi2BackOfficeCreateSubscriptionApiArg = {
  /** Request with inputs to create Subscription. */
  body: SprengnetterSprengConnectApiDtoRequestsCreateSubscriptionRequest;
};
export type PutServiceApi2BackOfficeUpdateSubscriptionApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelSubscription;
export type PutServiceApi2BackOfficeUpdateSubscriptionApiArg = {
  /** Id of the Subscription to update. */
  id?: number;
  /** Request with inputs to update Subscription. */
  body: SprengnetterSprengConnectApiDtoRequestsCreateSubscriptionRequest;
};
export type DeleteServiceApi2BackOfficeDeleteSubscriptionApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelSubscription;
export type DeleteServiceApi2BackOfficeDeleteSubscriptionApiArg = {
  /** Id of Subscription to delete. */
  id?: number;
};
export type GetServiceApi2BackOfficeGetUnassignedUsersApiResponse =
  /** status 200 OK */ AzureResponse601SystemCollectionsGenericList601ValuationHubCoreModelUserRead;
export type GetServiceApi2BackOfficeGetUnassignedUsersApiArg = void;
export type GetServiceApi2BackOfficeGetUsersByInstitutionApiResponse =
  /** status 200 OK */ AzureResponse601SystemCollectionsGenericList601ValuationHubCoreModelUserRead;
export type GetServiceApi2BackOfficeGetUsersByInstitutionApiArg = {
  /** Institution Id. */
  institutionId?: number;
};
export type PutServiceApi2BackOfficeAssignUserToInstitutionApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelUserRead;
export type PutServiceApi2BackOfficeAssignUserToInstitutionApiArg = {
  /** User Id. */
  userId?: string;
  /** Institution Id. */
  institutionId?: number;
};
export type PostServiceApi2BackOfficeCreateUserApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelUserRead;
export type PostServiceApi2BackOfficeCreateUserApiArg = {
  /** User's display name. */
  displayName?: string;
  /** User's email address. */
  emailAddress?: string;
  /** Set to true if the User can see his colleagues Valuations. */
  canViewInstitutionValuations?: boolean;
  /** Set to true if this User is an Institution Admin. */
  isInstitutionAdmin?: boolean;
};
export type PostServiceApi2BackOfficeCreateUserWithInstitutionApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelUserRead;
export type PostServiceApi2BackOfficeCreateUserWithInstitutionApiArg = {
  /** User's display name. */
  displayName?: string;
  /** User's email address. */
  emailAddress?: string;
  /** Id of the Institution the User belongs to. */
  institutionId?: number;
  /** Set to true if the User can see his colleagues Valuations. */
  canViewInstitutionValuations?: boolean;
  /** Set to true if this User is an Institution Admin. */
  isInstitutionAdmin?: boolean;
};
export type DeleteServiceApi2BackOfficeDeleteUserApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelUserRead;
export type DeleteServiceApi2BackOfficeDeleteUserApiArg = {
  /** Id of User to delete. */
  id?: string;
};
export type PutServiceApi2BackOfficeUpdateUserApiResponse =
  /** status 200 OK */ ValuationHubCoreModelUserRead;
export type PutServiceApi2BackOfficeUpdateUserApiArg = {
  /** Id of the User to update. */
  id?: string;
  /** Set to true if the User can see his colleagues Valuations. */
  canViewInstitutionValuations?: boolean;
  /** Set to true if this User is an Institution Admin. */
  isInstitutionAdmin?: boolean;
};
export type PostServiceApiBackOfficeSendInvitationApiResponse = unknown;
export type PostServiceApiBackOfficeSendInvitationApiArg = {
  /** User's Id. */
  id?: string;
};
export type GetServiceApi2BackOfficeEncryptApiResponse =
  /** status 200 OK */ string;
export type GetServiceApi2BackOfficeEncryptApiArg = {
  /** Decrypted password. */
  clearText?: string;
};
export type GetServiceApi2BackOfficeDecryptApiResponse =
  /** status 200 OK */ string;
export type GetServiceApi2BackOfficeDecryptApiArg = {
  /** Encrypted password. */
  encryptedText?: string;
};
export type PostServiceApi2BackOfficeValuationReportReloadAssetsApiResponse =
  unknown;
export type PostServiceApi2BackOfficeValuationReportReloadAssetsApiArg = void;
export type DeleteServiceApi2BackOfficeRemoveWidgetByIdApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelWidget;
export type DeleteServiceApi2BackOfficeRemoveWidgetByIdApiArg = {
  /** Id of the Widget to remove. */
  id: number;
};
export type PostServiceApiBatchesBatchApiResponse = unknown;
export type PostServiceApiBatchesBatchApiArg = {
  body: SprengnetterSprengConnectApiModelRequestBatchBatchUploadRequest;
};
export type PostServiceApiBatchesByUuidProcessedApiResponse = unknown;
export type PostServiceApiBatchesByUuidProcessedApiArg = {
  uuid: string;
  body: SprengnetterSprengConnectApiModelRequestBatchBatchProcessedRequest;
};
export type GetServiceApiBatchesStatusApiResponse =
  /** status 200 OK */ AzureResponse601ValuationHubCoreModelDtoBatchOutputStatusDtoRead;
export type GetServiceApiBatchesStatusApiArg = void;
export type GetServiceApiBatchesResultApiResponse =
  /** status 200 OK */ AzureResponse601SystemCollectionsGenericList601ValuationHubCoreModelCsvBatchOutputRead;
export type GetServiceApiBatchesResultApiArg = void;
export type GetServiceApiPingApiResponse = unknown;
export type GetServiceApiPingApiArg = void;
export type HeadServiceApiPingApiResponse = unknown;
export type HeadServiceApiPingApiArg = void;
export type PostServiceApiIndexIpivaluationApiResponse =
  /** status 200 OK */ SprengnetterAvmValuationModelsResponsesValuationIpiResponse;
export type PostServiceApiIndexIpivaluationApiArg = {
  body: SprengnetterAvmValuationModelsRequestsValuationIpiRequest;
};
export type PostServiceApiIndexIpirentApiResponse =
  /** status 200 OK */ SprengnetterAvmRentModelsResponsesRentIpiResponse;
export type PostServiceApiIndexIpirentApiArg = {
  body: SprengnetterAvmRentModelsRequestsRentIpiRequest;
};
export type PostServiceApiIndexSimApiResponse =
  /** status 200 OK */ SprengnetterAvmIndexModelsResponsesSimResponse;
export type PostServiceApiIndexSimApiArg = {
  body: SprengnetterAvmIndexModelsRequestsSimRequest;
};
export type PostServiceApiIndexSipnApiResponse =
  /** status 200 OK */ SprengnetterAvmIndexModelsResponsesSipnResponse;
export type PostServiceApiIndexSipnApiArg = {
  body: SprengnetterAvmIndexModelsRequestsSipnRequest;
};
export type PostServiceApiIndexSepiApiResponse =
  /** status 200 OK */ SprengnetterAvmIndexModelsResponsesSepiResponse;
export type PostServiceApiIndexSepiApiArg = {
  body: SprengnetterAvmIndexModelsRequestsSepiRequest;
};
export type PostServiceApiIndexValuationAipiApiResponse =
  /** status 200 OK */ SprengnetterAvmValuationModelsResponsesValuationAipiResponse;
export type PostServiceApiIndexValuationAipiApiArg = {
  body: SprengnetterAvmValuationModelsRequestsValuationAipiRequest;
};
export type PostServiceApiIndexDemandscoreApiResponse =
  /** status 200 OK */ SprengnetterAvmDemandScoreModelsResponsesDemandScoreResponse;
export type PostServiceApiIndexDemandscoreApiArg = {
  type?: SprengnetterAvmDemandScoreModelsRequestsDemandValuationType;
  body: SprengnetterAvmDemandScoreModelsRequestsDemandScoreRequest;
};
export type PostServiceApiIndexCrr3RiskDiscountApiResponse =
  /** status 200 OK */ SprengnetterAvmIndexModelsResponsesCrr3Response;
export type PostServiceApiIndexCrr3RiskDiscountApiArg = {
  body: SprengnetterAvmIndexModelsRequestsCrr3Request;
};
export type GetServiceApiIndexByIndexDocumentApiResponse = unknown;
export type GetServiceApiIndexByIndexDocumentApiArg = {
  index: ValuationHubCoreModelIndexType;
  documentType?: ValuationHubCoreModelDocumentType;
};
export type GetServiceApiInstitutionUsersApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonPaginatedResponse601SprengnetterValuationHubValuationPackageModelResponseInstitutionUserListItemResponse;
export type GetServiceApiInstitutionUsersApiArg = {
  after?: string;
  before?: string;
  pageSize?: number;
  sortDirection?: "Ascending" | "Descending";
  orderBy?: string;
  pageIndex?: number;
  searchTerm?: string;
  role?: ValuationHubCoreModelRole;
};
export type PutServiceApiInstitutionProfileSettingsApiResponse =
  /** status 200 OK */ AzureResponse601SprengnetterValuationHubApiModelResponseInstitutionProfileSettingsResponseRead;
export type PutServiceApiInstitutionProfileSettingsApiArg = {
  body: SprengnetterValuationHubApiModelRequestInstitutionProfileSettingsRequest;
};
export type GetServiceApiInstitutionProfileSettingsApiResponse =
  /** status 200 OK */ AzureResponse601SprengnetterValuationHubApiModelResponseInstitutionProfileSettingsResponseRead;
export type GetServiceApiInstitutionProfileSettingsApiArg = void;
export type PostServiceApiInstitutionCreateUserApiResponse =
  /** status 200 OK */ ValuationHubCoreModelUserRead;
export type PostServiceApiInstitutionCreateUserApiArg = {
  /** User's display name. */
  displayName?: string;
  /** User's email address. */
  emailAddress?: string;
  /** Set to true if the User can see his colleagues Valuations. */
  canViewInstitutionValuations?: boolean;
  /** Set to true if this User is an Institution Admin. */
  isInstitutionAdmin?: boolean;
};
export type DeleteServiceApiInstitutionDeleteUserApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonOperationResult601ValuationHubCoreModelUserRead;
export type DeleteServiceApiInstitutionDeleteUserApiArg = {
  /** Id of the User to delete. */
  id?: string;
};
export type PutServiceApiInstitutionUpdateUserApiResponse =
  /** status 200 OK */ ValuationHubCoreModelUserRead;
export type PutServiceApiInstitutionUpdateUserApiArg = {
  /** Id of the User to update. */
  id?: string;
  /** Set to true if the User can see his colleagues Valuations. */
  canViewInstitutionValuations?: boolean;
  /** Set to true if this User is an Institution Admin. */
  isInstitutionAdmin?: boolean;
};
export type GetServiceApiOktaHookApiResponse = /** status 200 OK */ any;
export type GetServiceApiOktaHookApiArg = {
  "X-Okta-Verification-Challenge"?: string;
};
export type PostServiceApiOktaHookApiResponse = unknown;
export type PostServiceApiOktaHookApiArg = {
  "X-Okta-Secret-Challenge"?: string;
};
export type PostServiceApiOktaHookPermissionsApiResponse = unknown;
export type PostServiceApiOktaHookPermissionsApiArg = {
  "X-Okta-Secret-Challenge"?: string;
};
export type PostServiceApiV2OneclickSoneApiResponse =
  /** status 200 OK */ SprengnetterValuationHubOneClickModelResponseSoneResponse;
export type PostServiceApiV2OneclickSoneApiArg = {
  orderType?: SprengnetterValuationHubSoneModelCommonProductType;
  body: ValuationHubCoreModelRealEstateValuationHubRealEstate;
};
export type PostServiceApiV2OneclickObjectPlatformApiResponse =
  /** status 200 OK */ SprengnetterValuationHubOneClickModelResponseObjectPlatformResponse;
export type PostServiceApiV2OneclickObjectPlatformApiArg = {
  body: SprengnetterValuationHubOneClickModelRequestObjectPlatformRequest;
};
export type PostServiceApiOutlierShieldPlausibilityCheckBySoneValuationIdApiResponse =
  /** status 200 OK */ SprengnetterValuationHubOutlierShieldModelResponsePlausibilityCheckResponse;
export type PostServiceApiOutlierShieldPlausibilityCheckBySoneValuationIdApiArg =
  {
    soneValuationId: string;
  };
export type PostServiceApiOutlierShieldGetPlausibilityCheckRequestBodyApiResponse =
  /** status 200 OK */ string;
export type PostServiceApiOutlierShieldGetPlausibilityCheckRequestBodyApiArg =
  void;
export type GetServiceApiProtocolDataInstitutionsApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonPaginatedResponse601SprengnetterValuationHubApiModelResponseProtocolProtocolDataInstitutionListResponse;
export type GetServiceApiProtocolDataInstitutionsApiArg = {
  after?: string;
  before?: string;
  pageSize?: number;
  sortDirection?: "Ascending" | "Descending";
  orderBy?: string;
  pageIndex?: number;
};
export type GetServiceApiShopProductsApiResponse = unknown;
export type GetServiceApiShopProductsApiArg = void;
export type PostServiceApiShopPurchasesByProductIdApiResponse = unknown;
export type PostServiceApiShopPurchasesByProductIdApiArg = {
  productId: number;
};
export type PostExchangeApiResponse = unknown;
export type PostExchangeApiArg = {
  /** Partner token. */
  token?: string;
  /** Partner ID (will be provided by Sprengnetter). */
  id?: string;
  /** The origin URL of the request. */
  origin?: string;
};
export type GetServiceApiUserPermissionsApiResponse =
  /** status 200 OK */ AzureResponse601ValuationHubCoreModelDtoUserPermissionsResponseRead;
export type GetServiceApiUserPermissionsApiArg = void;
export type PutServiceApiUserProfileSettingsApiResponse =
  /** status 200 OK */ AzureResponse601SprengnetterValuationHubApiModelResponseUserProfileSettingsResponseRead;
export type PutServiceApiUserProfileSettingsApiArg = {
  body: SprengnetterValuationHubApiModelRequestUserProfileSettingsRequest;
};
export type GetServiceApiUserProfileSettingsApiResponse =
  /** status 200 OK */ AzureResponse601SprengnetterValuationHubApiModelResponseUserProfileSettingsResponseRead;
export type GetServiceApiUserProfileSettingsApiArg = void;
export type GetServiceApiUserProfileApiResponse =
  /** status 200 OK */ AzureResponse601SprengnetterValuationHubApiModelResponseUserProfileResponseRead;
export type GetServiceApiUserProfileApiArg = void;
export type GetServiceApiValuationPackageStatusApiResponse =
  /** status 200 OK */ SprengnetterValuationHubValuationPackageModelResponseValuationPackageStatusResponse;
export type GetServiceApiValuationPackageStatusApiArg = void;
export type GetServiceApiValuationPackageInstitutionReportsApiResponse =
  /** status 200 OK */ SprengnetterSprengConnectApiModelResponseValuationPackageReportResponse[];
export type GetServiceApiValuationPackageInstitutionReportsApiArg = {
  generatedAtFrom?: string;
  generatedAtTo?: string;
};
export type GetServiceApiValuationPackageValuationsApiResponse =
  /** status 200 OK */ ValuationHubCoreCommonPaginatedResponse601SprengnetterValuationHubValuationPackageModelResponseValuationPackageListItemResponse;
export type GetServiceApiValuationPackageValuationsApiArg = {
  after?: string;
  before?: string;
  pageSize?: number;
  sortDirection?: "Ascending" | "Descending";
  orderBy?: string;
  pageIndex?: number;
  showOnlyMine?: boolean;
  addressSearchQuery?: string;
  nation?: string;
  town?: string;
  street?: string;
  houseNumber?: string;
  postCode?: string;
  createAtBefore?: string;
  createAtAfter?: string;
  buildingType?: ValuationHubCoreModelRealEstateEnumsBuildingType[];
};
export type PostServiceApiValuationPackageValuationApiResponse =
  /** status 200 OK */ SprengnetterValuationHubValuationPackageModelResponseValuationPackageItemResponseRead;
export type PostServiceApiValuationPackageValuationApiArg = {
  body: ValuationHubCoreModelRealEstateValuationHubRealEstate;
};
export type PostServiceApiValuationPackageValuationPartnerApiResponse =
  /** status 200 OK */ SprengnetterValuationHubValuationPackageModelResponseValuationPackageItemResponseRead;
export type PostServiceApiValuationPackageValuationPartnerApiArg = {
  pid?: string;
  body: ValuationHubCoreModelRealEstatePartnerValuationHubRealEstate;
};
export type PutServiceApiValuationPackageValuationByItemIdApiResponse =
  /** status 200 OK */ SprengnetterValuationHubValuationPackageModelResponseValuationPackageItemResponseRead;
export type PutServiceApiValuationPackageValuationByItemIdApiArg = {
  itemId: string;
  body: ValuationHubCoreModelRealEstateValuationHubRealEstateWithoutAddress;
};
export type GetServiceApiValuationPackageValuationByItemIdApiResponse =
  /** status 200 OK */ SprengnetterValuationHubValuationPackageModelResponseValuationPackageItemResponseRead;
export type GetServiceApiValuationPackageValuationByItemIdApiArg = {
  itemId: string;
};
export type DeleteServiceApiValuationPackageValuationByItemIdApiResponse =
  unknown;
export type DeleteServiceApiValuationPackageValuationByItemIdApiArg = {
  itemId: string;
};
export type PostServiceApiValuationPackageValuationByItemIdCopyApiResponse =
  /** status 200 OK */ SprengnetterValuationHubValuationPackageModelResponseValuationPackageItemResponseRead;
export type PostServiceApiValuationPackageValuationByItemIdCopyApiArg = {
  itemId: string;
};
export type PostServiceApiValuationPackageValuationByItemIdValuateApiResponse =
  /** status 200 OK */ SprengnetterValuationHubValuationPackageModelResponseValuationResultResponseRead;
export type PostServiceApiValuationPackageValuationByItemIdValuateApiArg = {
  itemId: string;
  valuationType?: ValuationHubCoreModelEnumsValuationType;
};
export type PostServiceApiValuationPackageValuationPartnervaluateApiResponse =
  /** status 200 OK */ SprengnetterValuationHubValuationPackageModelResponseValuationResultResponseRead;
export type PostServiceApiValuationPackageValuationPartnervaluateApiArg = {
  propertyId?: string;
  institutionId?: string;
  valuationType?: ValuationHubCoreModelEnumsValuationType;
};
export type PostServiceApiValuationPackageValuationByItemIdReportPdfApiResponse =
  unknown;
export type PostServiceApiValuationPackageValuationByItemIdReportPdfApiArg = {
  itemId: string;
  body: ValuationHubCoreModelDtoValuationReportConfigurationDto;
};
export type GetServiceApiValuationPackageValuationByItemIdReportPdfApiResponse =
  unknown;
export type GetServiceApiValuationPackageValuationByItemIdReportPdfApiArg = {
  itemId: string;
};
export type PostServiceApiValuationPackageValuationByItemIdReportDocxApiResponse =
  unknown;
export type PostServiceApiValuationPackageValuationByItemIdReportDocxApiArg = {
  itemId: string;
  body: ValuationHubCoreModelDtoValuationReportConfigurationDto;
};
export type GetServiceApiValuationPackageValuationByItemIdReportDocxApiResponse =
  unknown;
export type GetServiceApiValuationPackageValuationByItemIdReportDocxApiArg = {
  itemId: string;
};
export type PostServiceApiValuationPackageValuationByValuationPackageItemIdImageApiResponse =
  /** status 200 OK */ SprengnetterValuationHubValuationPackageDtoResponsesUploadImageResponse;
export type PostServiceApiValuationPackageValuationByValuationPackageItemIdImageApiArg =
  {
    /** The unique identifier of the valuation package item to which the image will be attached. */
    valuationPackageItemId: string;
    body: {
      File?: Blob;
      Title?: string;
      IsProfilePicture?: boolean;
    };
  };
export type PostServiceApiValuationPackageValuationPartnerByValuationPackageItemIdImagesApiResponse =
  /** status 200 OK */ SprengnetterValuationHubValuationPackageDtoResponsesUploadImageResponse[];
export type PostServiceApiValuationPackageValuationPartnerByValuationPackageItemIdImagesApiArg =
  {
    /** The Id of the Valuation Package Item to which the images will be attached. */
    valuationPackageItemId: string;
    /** A collection of Partner images to be uploaded. ValuationHub.Core.Model.RealEstate.PartnerImage */
    body: ValuationHubCoreModelRealEstatePartnerImage[];
  };
export type DeleteServiceApiValuationPackageValuationImageByIdApiResponse =
  unknown;
export type DeleteServiceApiValuationPackageValuationImageByIdApiArg = {
  /** The unique identifier of the valuation image to delete. */
  id: string;
};
export type GetServiceApiValuationPackageValuationByValuationPackageItemIdImagesApiResponse =
  /** status 200 OK */ ValuationHubCoreModelImageRead[];
export type GetServiceApiValuationPackageValuationByValuationPackageItemIdImagesApiArg =
  {
    /** The unique identifier of the valuation package item for which to retrieve images. */
    valuationPackageItemId: string;
  };
export type PutServiceApiValuationPackageValuationByValuationPackageItemIdImagesApiResponse =
  unknown;
export type PutServiceApiValuationPackageValuationByValuationPackageItemIdImagesApiArg =
  {
    /** The unique identifier of the valuation package item whose images are to be updated. */
    valuationPackageItemId: string;
    /** An object containing the updated list of images for the valuation package item. Cannot be null. */
    body: SprengnetterValuationHubValuationPackageDtoRequestsValuationPackageItemImagesUpdateRequest;
  };
export type GetServiceApiValuationReportLoginApiResponse = unknown;
export type GetServiceApiValuationReportLoginApiArg = {
  realEstateId?: string;
  provider?: string;
};
export type GetServiceApiValuationReportLoginCallbackByRealEstateIdApiResponse =
  unknown;
export type GetServiceApiValuationReportLoginCallbackByRealEstateIdApiArg = {
  realEstateId: string;
  oauthToken?: string;
  oauthVerifier?: string;
  provider?: string;
  state?: string;
};
export type GetServiceApiValuationReportStatusApiResponse =
  /** status 200 OK */ SprengnetterValuationHubValuationReportModelResponseValuationReportStatusResponseRead;
export type GetServiceApiValuationReportStatusApiArg = {
  /** Session id having given real estate bound to it */
  "X-Session-Token": string;
};
export type GetServiceApiValuationReportRealEstateApiResponse =
  /** status 200 OK */ ValuationHubCoreModelRealEstateValuationHubRealEstate;
export type GetServiceApiValuationReportRealEstateApiArg = {
  /** Session id having given real estate bound to it */
  "X-Session-Token": string;
};
export type PutServiceApiValuationReportRealEstateApiResponse =
  /** status 200 OK */ ValuationHubCoreModelRealEstateValuationHubRealEstate;
export type PutServiceApiValuationReportRealEstateApiArg = {
  /** Session id having given real estate bound to it */
  "X-Session-Token": string;
  body: ValuationHubCoreModelRealEstateValuationHubRealEstateWithoutAddress;
};
export type GetServiceApiValuationReportRealEstateImagesApiResponse =
  /** status 200 OK */ ValuationHubCoreModelDtoValuationReportImageDto[];
export type GetServiceApiValuationReportRealEstateImagesApiArg = {
  /** Session id having given real estate bound to it */
  "X-Session-Token": string;
};
export type GetServiceApiValuationReportRealEstateContactApiResponse =
  /** status 200 OK */ ValuationHubCoreModelDtoContactInformationDto;
export type GetServiceApiValuationReportRealEstateContactApiArg = {
  /** Session id having given real estate bound to it */
  "X-Session-Token": string;
};
export type GetServiceApiValuationReportAvmValuateApiResponse =
  /** status 200 OK */ SprengnetterValuationHubValuationReportModelResponseAvmPriceResponse;
export type GetServiceApiValuationReportAvmValuateApiArg = {
  /** Session id having given real estate bound to it */
  "X-Session-Token": string;
};
export type GetServiceApiValuationReportSoneValuateApiResponse =
  /** status 200 OK */ SprengnetterValuationHubValuationReportModelResponseSonePriceResponse;
export type GetServiceApiValuationReportSoneValuateApiArg = {
  /** Session id having given real estate bound to it */
  "X-Session-Token": string;
};
export type GetServiceApiValuationReportProsawebValuateApiResponse =
  /** status 200 OK */ SprengnetterValuationHubProsaWebModelResponseProsaWebResponseRead;
export type GetServiceApiValuationReportProsawebValuateApiArg = {
  /** Session id having given real estate bound to it */
  "X-Session-Token": string;
};
export type PostServiceApiValuationReportReportApiResponse = unknown;
export type PostServiceApiValuationReportReportApiArg = {
  /** Session id having given real estate bound to it */
  "X-Session-Token": string;
  body: ValuationHubCoreModelDtoValuationReportConfigurationDto;
};
export type GetServiceApiValuationReportReportApiResponse = unknown;
export type GetServiceApiValuationReportReportApiArg = {
  /** Session id having given real estate bound to it */
  "X-Session-Token": string;
};
export type PostServiceApiSimApiResponse =
  /** status 200 OK */ SprengnetterAvmIndexModelsResponsesSimResponse;
export type PostServiceApiSimApiArg = {
  body: SprengnetterAvmIndexModelsRequestsSimRequest;
};
export type PostServiceApiSipnApiResponse =
  /** status 200 OK */ SprengnetterAvmIndexModelsResponsesSipnResponse;
export type PostServiceApiSipnApiArg = {
  body: SprengnetterAvmIndexModelsRequestsSipnRequest;
};
export type ValuationHubCoreCommonOperationFailureReason =
  | "None"
  | "InvalidId"
  | "NotFound"
  | "HasAssociatedEntities"
  | "RemoveDefaultNotAllowed"
  | "ValidationFailed"
  | "Conflict"
  | "Unauthorized"
  | "UnknownError"
  | "AlreadyExists";
export type ValuationHubCoreModelFeatureType =
  | "PLAYGROUND"
  | "DOCUMENT_DOWNLOAD"
  | "PORTFOLIO";
export type ValuationHubCoreModelIndexType =
  | "SIPI"
  | "SIPN"
  | "SIM"
  | "SEPI"
  | "VALUATION_AIPI"
  | "CRR3_RISK_DISCOUNT";
export type ValuationHubCoreModelBatchStatus =
  | "IN_PROGRESS"
  | "COMPLETED"
  | "ERROR";
export type ValuationHubCoreModelPartnerTokenEncryptionMethod = 1 | 2 | 3;
export type ValuationHubCoreModelVpiCreationPolicyType = 1 | 2 | 3;
export type ValuationHubCoreModelReportGenerationPolicyType = 1 | 2;
export type ValuationHubCoreModelVpiCreatedActionPolicyType = 1 | 2 | 3;
export type ValuationHubCoreModelEntitlementProfile = {
  id?: number;
  name: string | null;
  vpi_creation_policy?: ValuationHubCoreModelVpiCreationPolicyType;
  report_generation_policy?: ValuationHubCoreModelReportGenerationPolicyType;
  vpi_created_policy?: ValuationHubCoreModelVpiCreatedActionPolicyType;
  authentication_sources?: ValuationHubCoreModelAuthenticationSource[] | null;
};
export type ValuationHubCoreModelEntitlementProfileRead = {
  id?: number;
  name: string | null;
  vpi_creation_policy?: ValuationHubCoreModelVpiCreationPolicyType;
  report_generation_policy?: ValuationHubCoreModelReportGenerationPolicyType;
  vpi_created_policy?: ValuationHubCoreModelVpiCreatedActionPolicyType;
  authentication_sources?: ValuationHubCoreModelAuthenticationSource[] | null;
};
export type ValuationHubCoreModelAuthenticationSource = {
  id?: number;
  name: string | null;
  authentication_source_key: string | null;
  partner_id?: string;
  partner?: ValuationHubCoreModelPartner | null;
  entitlement_profile_id?: number;
  entitlement_profile?: ValuationHubCoreModelEntitlementProfile | null;
  users?: ValuationHubCoreModelUser[] | null;
  default_institution_id?: number | null;
  default_institution?: ValuationHubCoreModelInstitution | null;
};
export type ValuationHubCoreModelAuthenticationSourceRead = {
  id?: number;
  name: string | null;
  authentication_source_key: string | null;
  partner_id?: string;
  partner?: ValuationHubCoreModelPartner | null;
  entitlement_profile_id?: number;
  entitlement_profile?: ValuationHubCoreModelEntitlementProfileRead | null;
  users?: ValuationHubCoreModelUser[] | null;
  default_institution_id?: number | null;
  default_institution?: ValuationHubCoreModelInstitution | null;
};
export type ValuationHubCoreModelPartner = {
  id?: string;
  name: string | null;
  contact_email?: string | null;
  origin_url: string | null;
  secrets: string | null;
  partner_token_encryption_method_id?: number;
  get_data_url?: string | null;
  partner_token_encryption_method?: ValuationHubCoreModelPartnerTokenEncryptionMethod;
  default_booked_valuations_count?: number | null;
  default_expiration_date?: string | null;
  users?: ValuationHubCoreModelUser[] | null;
  institutions?: ValuationHubCoreModelInstitution[] | null;
  authentication_sources?: ValuationHubCoreModelAuthenticationSource[] | null;
};
export type ValuationHubCoreModelPartnerRead = {
  id?: string;
  name: string | null;
  contact_email?: string | null;
  origin_url: string | null;
  secrets: string | null;
  partner_token_encryption_method_id?: number;
  get_data_url?: string | null;
  partner_token_encryption_method?: ValuationHubCoreModelPartnerTokenEncryptionMethod;
  default_booked_valuations_count?: number | null;
  default_expiration_date?: string | null;
  users?: ValuationHubCoreModelUser[] | null;
  institutions?: ValuationHubCoreModelInstitution[] | null;
  authentication_sources?:
    | ValuationHubCoreModelAuthenticationSourceRead[]
    | null;
};
export type ValuationHubCoreModelPermission = {
  subscription_id?: number;
  index_id?: number;
  feature_id?: number;
  subscription?: ValuationHubCoreModelSubscription | null;
  index?: ValuationHubCoreModelIndex | null;
  feature?: ValuationHubCoreModelFeature | null;
};
export type ValuationHubCoreModelSubscription = {
  id?: number;
  description?: string | null;
  name?: string | null;
  institution_subscriptions?:
    | ValuationHubCoreModelInstitutionSubscription[]
    | null;
  permissions?: ValuationHubCoreModelPermission[] | null;
};
export type ValuationHubCoreModelInstitutionSubscription = {
  institution_id?: number;
  subscription_id?: number;
  expiration_date?: string | null;
  is_active?: boolean;
  institution?: ValuationHubCoreModelInstitution | null;
  subscription?: ValuationHubCoreModelSubscription | null;
};
export type ValuationHubCoreModelInstitutionSubscriptionRead = {
  institution_id?: number;
  subscription_id?: number;
  expiration_date?: string | null;
  is_active?: boolean;
  institution?: ValuationHubCoreModelInstitution | null;
  subscription?: ValuationHubCoreModelSubscription | null;
};
export type ValuationHubCoreModelWidget = {
  id?: number;
  institution_id?: number | null;
  api_key?: string | null;
  allowed_origin_url?: string | null;
  is_active?: boolean | null;
  institution?: ValuationHubCoreModelInstitution | null;
};
export type ValuationHubCoreModelWidgetRead = {
  id?: number;
  institution_id?: number | null;
  api_key?: string | null;
  allowed_origin_url?: string | null;
  is_active?: boolean | null;
  institution?: ValuationHubCoreModelInstitution | null;
};
export type ValuationHubCoreModelSOneSettingsType =
  | "OneClick"
  | "OutlierShield"
  | "ValuationsPackage";
export type ValuationHubCoreModelSOneSettings = {
  id?: number;
  institution_id?: number;
  one_server_password: string | null;
  one_server_username: string | null;
  one_server_institution_identifier: string | null;
  api_one_server_url: string | null;
  ui_one_server_url: string | null;
  institution?: ValuationHubCoreModelInstitution | null;
  s_one_settings_type_id?: number | null;
  s_one_settings_type?: ValuationHubCoreModelSOneSettingsType;
};
export type ValuationHubCoreModelSOneSettingsRead = {
  id?: number;
  institution_id?: number;
  one_server_password: string | null;
  one_server_username: string | null;
  one_server_institution_identifier: string | null;
  api_one_server_url: string | null;
  ui_one_server_url: string | null;
  institution?: ValuationHubCoreModelInstitution | null;
  s_one_settings_type_id?: number | null;
  s_one_settings_type?: ValuationHubCoreModelSOneSettingsType;
};
export type ValuationHubCoreModelValuationsPackage = {
  id?: number;
  institution_id?: number;
  institution?: ValuationHubCoreModelInstitution | null;
  booking_date?: string;
  expiration_date?: string | null;
  booked_valuations_count?: number;
  remaining_valuations_count?: number;
  valuations_count_reset_date?: string;
};
export type ValuationHubCoreModelValuationsPackageRead = {
  id?: number;
  institution_id?: number;
  institution?: ValuationHubCoreModelInstitution | null;
  booking_date?: string;
  expiration_date?: string | null;
  booked_valuations_count?: number;
  remaining_valuations_count?: number;
  valuations_count_reset_date?: string;
  valuations_package_settings?: ValuationHubCoreModelSOneSettingsRead | null;
};
export type ValuationHubCoreModelInstitutionProfile = {
  id?: string;
  company_name?: string | null;
  house_number?: string | null;
  street?: string | null;
  town?: string | null;
  post_code?: string | null;
  website?: string | null;
  primary_color?: string | null;
  company_logo_url?: string | null;
  user_id?: string | null;
  user?: ValuationHubCoreModelUser | null;
  institution_id?: number | null;
  institution?: ValuationHubCoreModelInstitution | null;
};
export type ValuationHubCoreModelInstitutionProfileRead = {
  id?: string;
  company_name?: string | null;
  house_number?: string | null;
  street?: string | null;
  town?: string | null;
  post_code?: string | null;
  website?: string | null;
  primary_color?: string | null;
  company_logo_url?: string | null;
  user_id?: string | null;
  user?: ValuationHubCoreModelUser | null;
  institution_id?: number | null;
  institution?: ValuationHubCoreModelInstitution | null;
};
export type ValuationHubCoreModelInstitution = {
  id?: number;
  name: string | null;
  nation?: string | null;
  town?: string | null;
  street?: string | null;
  zip?: string | null;
  house_number?: number | null;
  one_click_enabled?: boolean | null;
  valuations_package_enabled?: boolean | null;
  outlier_shield_enabled?: boolean | null;
  external_institution_id?: string | null;
  partner_id?: string;
  partner?: ValuationHubCoreModelPartner | null;
  institution_subscription?: ValuationHubCoreModelInstitutionSubscription | null;
  users?: ValuationHubCoreModelUser[] | null;
  widgets?: ValuationHubCoreModelWidget[] | null;
  default_for_authentication_sources?:
    | ValuationHubCoreModelAuthenticationSource[]
    | null;
  settings?: ValuationHubCoreModelSOneSettings[] | null;
  valuations_package?: ValuationHubCoreModelValuationsPackage | null;
  institution_profile?: ValuationHubCoreModelInstitutionProfile | null;
};
export type ValuationHubCoreModelInstitutionRead = {
  id?: number;
  name: string | null;
  nation?: string | null;
  town?: string | null;
  street?: string | null;
  zip?: string | null;
  house_number?: number | null;
  one_click_enabled?: boolean | null;
  valuations_package_enabled?: boolean | null;
  outlier_shield_enabled?: boolean | null;
  external_institution_id?: string | null;
  partner_id?: string;
  partner?: ValuationHubCoreModelPartnerRead | null;
  institution_subscription?: ValuationHubCoreModelInstitutionSubscriptionRead | null;
  users?: ValuationHubCoreModelUser[] | null;
  widgets?: ValuationHubCoreModelWidgetRead[] | null;
  default_for_authentication_sources?:
    | ValuationHubCoreModelAuthenticationSourceRead[]
    | null;
  settings?: ValuationHubCoreModelSOneSettingsRead[] | null;
  one_click_settings?: ValuationHubCoreModelSOneSettingsRead | null;
  outlier_shield_settings?: ValuationHubCoreModelSOneSettingsRead | null;
  valuations_package_settings?: ValuationHubCoreModelSOneSettingsRead | null;
  valuations_package?: ValuationHubCoreModelValuationsPackageRead | null;
  institution_profile?: ValuationHubCoreModelInstitutionProfileRead | null;
};
export type ValuationHubCoreModelRole =
  | "None"
  | "User"
  | "InstitutionAdmin"
  | "Admin";
export type ValuationHubCoreModelUserProfile = {
  id?: string;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone_number?: string | null;
  profile_picture_url?: string | null;
  override_institution_profile?: boolean | null;
  user_id: string;
  user?: ValuationHubCoreModelUser | null;
};
export type ValuationHubCoreModelUserProfileRead = {
  id?: string;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone_number?: string | null;
  profile_picture_url?: string | null;
  override_institution_profile?: boolean | null;
  user_id: string;
  user?: ValuationHubCoreModelUser | null;
};
export type ValuationHubCoreModelAccountStatus =
  | "ACTIVE"
  | "PENDING"
  | "OTHER"
  | "UNASSIGNED_FROM_APP";
export type ValuationHubCoreModelPurchasableProduct = {
  id?: number;
  external_shop_product_number: string | null;
  external_shop_product_id: string | null;
  name?: string | null;
  description?: string | null;
  valuations_to_add?: number;
  purchases?: ValuationHubCoreModelPurchase[] | null;
  price?: number;
};
export type ValuationHubCoreModelPurchaseStatus = 1 | 2 | 3 | 4 | 5 | 6;
export type ValuationHubCoreModelPurchase = {
  id?: string;
  user_id?: string | null;
  user_name?: string | null;
  user_email?: string | null;
  institution_id?: number;
  institution_name?: string | null;
  user?: ValuationHubCoreModelUser | null;
  purchasable_product_id?: number;
  purchasable_product?: ValuationHubCoreModelPurchasableProduct | null;
  product_name?: string | null;
  product_description?: string | null;
  external_shop_id?: string | null;
  external_shop_order_id?: string | null;
  external_shop_transaction_id?: string | null;
  checkout_redirect_url?: string | null;
  valuations_count?: number;
  price?: number;
  currency?: string | null;
  created_at?: string;
  paid_at?: string | null;
  failed_at?: string | null;
  cancelled_at?: string | null;
  purchase_status_id?: number;
  purchase_status?: ValuationHubCoreModelPurchaseStatus;
};
export type ValuationHubCoreModelPurchaseRead = {
  id?: string;
  user_id?: string | null;
  user_name?: string | null;
  user_email?: string | null;
  institution_id?: number;
  institution_name?: string | null;
  user?: ValuationHubCoreModelUser | null;
  purchasable_product_id?: number;
  purchasable_product?: ValuationHubCoreModelPurchasableProduct | null;
  product_name?: string | null;
  product_description?: string | null;
  external_shop_id?: string | null;
  external_shop_order_id?: string | null;
  external_shop_transaction_id?: string | null;
  checkout_redirect_url?: string | null;
  valuations_count?: number;
  price?: number;
  currency?: string | null;
  created_at?: string;
  paid_at?: string | null;
  failed_at?: string | null;
  cancelled_at?: string | null;
  purchase_status_id?: number;
  purchase_status?: ValuationHubCoreModelPurchaseStatus;
};
export type ValuationHubCoreModelUser = {
  id: string | null;
  display_name?: string | null;
  email_address?: string | null;
  updated_at?: string | null;
  institution_id?: number;
  institution?: ValuationHubCoreModelInstitution | null;
  can_view_institution_valuations?: boolean | null;
  batches?: ValuationHubCoreModelBatch[] | null;
  role_flags?: number;
  roles?: ValuationHubCoreModelRole;
  user_profile?: ValuationHubCoreModelUserProfile | null;
  institution_profile?: ValuationHubCoreModelInstitutionProfile | null;
  account_status_id?: number;
  account_status?: ValuationHubCoreModelAccountStatus;
  purchases?: ValuationHubCoreModelPurchase[] | null;
  external_user_id?: string | null;
  partner_id?: string;
  partner?: ValuationHubCoreModelPartner | null;
  authentication_source_id?: number;
  authentication_source?: ValuationHubCoreModelAuthenticationSource | null;
};
export type ValuationHubCoreModelUserRead = {
  id: string | null;
  display_name?: string | null;
  email_address?: string | null;
  updated_at?: string | null;
  institution_id?: number;
  institution?: ValuationHubCoreModelInstitutionRead | null;
  can_view_institution_valuations?: boolean | null;
  batches?: ValuationHubCoreModelBatch[] | null;
  role_flags?: number;
  roles?: ValuationHubCoreModelRole;
  user_profile?: ValuationHubCoreModelUserProfileRead | null;
  institution_profile?: ValuationHubCoreModelInstitutionProfileRead | null;
  account_status_id?: number;
  account_status?: ValuationHubCoreModelAccountStatus;
  purchases?: ValuationHubCoreModelPurchaseRead[] | null;
  external_user_id?: string | null;
  partner_id?: string;
  partner?: ValuationHubCoreModelPartnerRead | null;
  authentication_source_id?: number;
  authentication_source?: ValuationHubCoreModelAuthenticationSourceRead | null;
};
export type ValuationHubCoreModelBatch = {
  id: string | null;
  user_id: string | null;
  file_name?: string | null;
  result_file_name?: string | null;
  index_id?: number;
  index?: ValuationHubCoreModelIndex | null;
  status_id?: number;
  status?: ValuationHubCoreModelBatchStatus;
  user?: ValuationHubCoreModelUser | null;
};
export type ValuationHubCoreModelBatchRead = {
  id: string | null;
  user_id: string | null;
  file_name?: string | null;
  result_file_name?: string | null;
  index_id?: number;
  index?: ValuationHubCoreModelIndex | null;
  status_id?: number;
  status?: ValuationHubCoreModelBatchStatus;
  user?: ValuationHubCoreModelUserRead | null;
};
export type ValuationHubCoreModelDocument = {
  id?: number;
  index_id?: number;
  name?: string | null;
  url?: string | null;
  index?: ValuationHubCoreModelIndex | null;
};
export type ValuationHubCoreModelIndex = {
  id?: number;
  name?: ValuationHubCoreModelIndexType;
  data_cut_off_date?: string | null;
  batches?: ValuationHubCoreModelBatch[] | null;
  documents?: ValuationHubCoreModelDocument[] | null;
  features?: ValuationHubCoreModelFeature[] | null;
};
export type ValuationHubCoreModelFeature = {
  id?: number;
  name?: ValuationHubCoreModelFeatureType;
  indexes?: ValuationHubCoreModelIndex[] | null;
};
export type ValuationHubCoreCommonOperationResult601ValuationHubCoreModelFeature =
  {
    is_successful?: boolean;
    reason?: ValuationHubCoreCommonOperationFailureReason;
    message?: string | null;
    data?: ValuationHubCoreModelFeature | null;
  };
export type SprengnetterAvmClientModelsResponsesErrorsErrorResponse = {
  errors?:
    | {
        [key: string]: string;
      }[]
    | null;
};
export type ValuationHubCoreCommonOperationResult601ValuationHubCoreModelDocument =
  {
    is_successful?: boolean;
    reason?: ValuationHubCoreCommonOperationFailureReason;
    message?: string | null;
    data?: ValuationHubCoreModelDocument | null;
  };
export type AzureResponse601SystemCollectionsGenericList601SprengnetterSprengConnectApiDtoResponsesIndexFeaturesDto =
  {};
export type SprengnetterSprengConnectApiDtoResponsesIndexFeaturesDto = {
  index: ValuationHubCoreModelIndexType;
  feature_name: ValuationHubCoreModelFeatureType;
};
export type AzureResponse601SystemCollectionsGenericList601SprengnetterSprengConnectApiDtoResponsesIndexFeaturesDtoRead =
  {
    has_value?: boolean;
    value?: SprengnetterSprengConnectApiDtoResponsesIndexFeaturesDto[] | null;
  };
export type AzureResponse601SystemCollectionsGenericList601ValuationHubCoreModelFeature =
  {};
export type AzureResponse601SystemCollectionsGenericList601ValuationHubCoreModelFeatureRead =
  {
    has_value?: boolean;
    value?: ValuationHubCoreModelFeature[] | null;
  };
export type SprengnetterSprengConnectApiDtoResponsesSubscriptionDto = {
  id?: number;
  name?: string | null;
  description?: string | null;
};
export type SprengnetterSprengConnectApiDtoResponsesFeatureDto = {
  feature_id?: number;
  name?: ValuationHubCoreModelFeatureType;
  subscriptions?:
    | SprengnetterSprengConnectApiDtoResponsesSubscriptionDto[]
    | null;
};
export type SprengnetterSprengConnectApiDtoResponsesDocumentDto = {
  id?: number;
  name?: string | null;
  url?: string | null;
};
export type SprengnetterSprengConnectApiDtoResponsesIndexDto = {
  id?: number;
  name?: ValuationHubCoreModelIndexType;
  data_cut_off_date?: string | null;
  features?: SprengnetterSprengConnectApiDtoResponsesFeatureDto[] | null;
  documents?: SprengnetterSprengConnectApiDtoResponsesDocumentDto[] | null;
  subscriptions?:
    | SprengnetterSprengConnectApiDtoResponsesSubscriptionDto[]
    | null;
};
export type ValuationHubCoreCommonOperationResult601ValuationHubCoreModelIndex =
  {
    is_successful?: boolean;
    reason?: ValuationHubCoreCommonOperationFailureReason;
    message?: string | null;
    data?: ValuationHubCoreModelIndex | null;
  };
export type SprengnetterSprengConnectApiDtoResponsesSOneSettingDto = {
  id?: number | null;
  institution_id?: number | null;
  one_server_password?: string | null;
  one_server_username?: string | null;
  one_server_institution_identifier?: string | null;
  api_one_server_url?: string | null;
  ui_one_server_url?: string | null;
};
export type SprengnetterSprengConnectApiDtoResponsesValuationsPackageDto = {
  id?: number | null;
  booking_date?: string | null;
  expiration_date?: string | null;
  booked_valuations_count?: number | null;
  remaining_valuations_count?: number | null;
  one_server_password?: string | null;
  one_server_username?: string | null;
  one_server_institution_identifier?: string | null;
  api_one_server_url?: string | null;
  ui_one_server_url?: string | null;
};
export type SprengnetterSprengConnectApiDtoResponsesWidgetDto = {
  id?: number;
  api_key?: string | null;
  allowed_origin_url?: string | null;
  is_active?: boolean;
};
export type SprengnetterSprengConnectApiDtoResponsesInstitutionDto = {
  id?: number;
  name?: string | null;
  nation?: string | null;
  town?: string | null;
  street?: string | null;
  zip?: string | null;
  house_number?: number | null;
  subscription_id?: number;
  expiration_date?: string | null;
  is_active?: boolean;
  api_one_server_url?: string | null;
  ui_one_server_url?: string | null;
  one_click_enabled?: boolean | null;
  one_click?: SprengnetterSprengConnectApiDtoResponsesSOneSettingDto | null;
  outlier_shield_enabled?: boolean | null;
  outlier_shield?: SprengnetterSprengConnectApiDtoResponsesSOneSettingDto | null;
  valuations_package_enabled?: boolean | null;
  valuations_package?: SprengnetterSprengConnectApiDtoResponsesValuationsPackageDto | null;
  widgets?: SprengnetterSprengConnectApiDtoResponsesWidgetDto[] | null;
};
export type ValuationHubCoreCommonMetaPagination = {
  after?: string | null;
  before?: string | null;
  page_size?: number;
  total_records?: number | null;
  page_index?: number | null;
  order_by?: string | null;
  sort_direction?: "Ascending" | "Descending";
  has_more?: boolean | null;
};
export type SprengnetterSprengConnectApiDtoResponsesInstitutionsResponse = {
  data?: SprengnetterSprengConnectApiDtoResponsesInstitutionDto[] | null;
  pagination?: ValuationHubCoreCommonMetaPagination | null;
};
export type SprengnetterSprengConnectApiDtoResponsesInstitutionShortDto = {
  id?: number;
  name: string | null;
};
export type ValuationHubCoreModelDtoWidgetDto = {
  id?: number | null;
  institution_id?: number | null;
  api_key?: string | null;
  allowed_origin_url?: string | null;
  is_active?: boolean;
};
export type ValuationHubCoreModelDtoSOneSettingDto = {
  id?: number;
  institution_id?: number;
  one_server_password: string | null;
  one_server_username: string | null;
  one_server_institution_identifier: string | null;
  api_one_server_url: string | null;
  ui_one_server_url: string | null;
};
export type ValuationHubCoreModelDtoValuationsPackageDto = {
  booked_valuations_count?: number;
  booking_date?: string;
  expiration_date?: string;
  one_server_password: string | null;
  one_server_username: string | null;
  one_server_institution_identifier: string | null;
  api_one_server_url: string | null;
  ui_one_server_url: string | null;
};
export type ValuationHubCoreModelDtoInstitutionDto = {
  name: string | null;
  nation?: string | null;
  town?: string | null;
  street?: string | null;
  zip?: string | null;
  house_number?: number | null;
  subscription_id?: number | null;
  expiration_date?: string | null;
  is_active?: boolean;
  one_click_enabled?: boolean | null;
  outlier_shield_enabled?: boolean | null;
  valuations_package_enabled?: boolean | null;
  widgets?: ValuationHubCoreModelDtoWidgetDto[] | null;
  one_click?: ValuationHubCoreModelDtoSOneSettingDto | null;
  outlier_shield?: ValuationHubCoreModelDtoSOneSettingDto | null;
  valuations_package?: ValuationHubCoreModelDtoValuationsPackageDto | null;
};
export type ValuationHubCoreCommonOperationResult601SprengnetterSprengConnectApiDtoResponsesInstitutionDto =
  {
    is_successful?: boolean;
    reason?: ValuationHubCoreCommonOperationFailureReason;
    message?: string | null;
    data?: SprengnetterSprengConnectApiDtoResponsesInstitutionDto | null;
  };
export type ValuationHubCoreCommonOperationResult601ValuationHubCoreModelInstitution =
  {
    is_successful?: boolean;
    reason?: ValuationHubCoreCommonOperationFailureReason;
    message?: string | null;
    data?: ValuationHubCoreModelInstitution | null;
  };
export type ValuationHubCoreCommonOperationResult601ValuationHubCoreModelInstitutionRead =
  {
    is_successful?: boolean;
    reason?: ValuationHubCoreCommonOperationFailureReason;
    message?: string | null;
    data?: ValuationHubCoreModelInstitutionRead | null;
  };
export type AzureResponse601SystemCollectionsGenericList601SprengnetterSprengConnectApiDtoResponsesAssignedInstitutionsToSubscriptionDto =
  {};
export type SprengnetterSprengConnectApiDtoResponsesAssignedInstitutionsToSubscriptionDto =
  {
    institution_id?: number;
    institution_name: string | null;
    is_active?: boolean;
    expiration_date?: string | null;
  };
export type AzureResponse601SystemCollectionsGenericList601SprengnetterSprengConnectApiDtoResponsesAssignedInstitutionsToSubscriptionDtoRead =
  {
    has_value?: boolean;
    value?:
      | SprengnetterSprengConnectApiDtoResponsesAssignedInstitutionsToSubscriptionDto[]
      | null;
  };
export type MicrosoftAspNetCoreMvcProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type ValuationHubCoreCommonOperationResult601ValuationHubCoreModelPermission =
  {
    is_successful?: boolean;
    reason?: ValuationHubCoreCommonOperationFailureReason;
    message?: string | null;
    data?: ValuationHubCoreModelPermission | null;
  };
export type SprengnetterSprengConnectApiDtoRequestsCreateSubscriptionPermission =
  {
    index?: ValuationHubCoreModelIndexType;
    feature?: ValuationHubCoreModelFeatureType;
  };
export type SprengnetterSprengConnectApiDtoRequestsCreateSubscriptionRequest = {
  name: string | null;
  description?: string | null;
  permissions?:
    | SprengnetterSprengConnectApiDtoRequestsCreateSubscriptionPermission[]
    | null;
};
export type ValuationHubCoreCommonOperationResult601ValuationHubCoreModelSubscription =
  {
    is_successful?: boolean;
    reason?: ValuationHubCoreCommonOperationFailureReason;
    message?: string | null;
    data?: ValuationHubCoreModelSubscription | null;
  };
export type AzureResponse601SystemCollectionsGenericList601ValuationHubCoreModelUser =
  {};
export type AzureResponse601SystemCollectionsGenericList601ValuationHubCoreModelUserRead =
  {
    has_value?: boolean;
    value?: ValuationHubCoreModelUserRead[] | null;
  };
export type ValuationHubCoreCommonOperationResult601ValuationHubCoreModelUser =
  {
    is_successful?: boolean;
    reason?: ValuationHubCoreCommonOperationFailureReason;
    message?: string | null;
    data?: ValuationHubCoreModelUser | null;
  };
export type ValuationHubCoreCommonOperationResult601ValuationHubCoreModelUserRead =
  {
    is_successful?: boolean;
    reason?: ValuationHubCoreCommonOperationFailureReason;
    message?: string | null;
    data?: ValuationHubCoreModelUserRead | null;
  };
export type ValuationHubCoreCommonOperationResult601ValuationHubCoreModelWidget =
  {
    is_successful?: boolean;
    reason?: ValuationHubCoreCommonOperationFailureReason;
    message?: string | null;
    data?: ValuationHubCoreModelWidget | null;
  };
export type SprengnetterAvmClientModelsCommonNation = "DE" | "AT" | "IT";
export type SprengnetterAvmClientModelsCommonCategory =
  | "ETW"
  | "CONDOMINIUM"
  | "EFH"
  | "SINGLE_FAMILY_HOUSE"
  | "MFH"
  | "MULTI_FAMILY_DWELLING"
  | "GRD"
  | "UNDEVELOPED_PLOT";
export type ValuationHubCoreModelCsvBatchInput = {
  nation?: SprengnetterAvmClientModelsCommonNation | null;
  street?: string | null;
  house_number?: string | null;
  zip: string;
  town?: string | null;
  category?: SprengnetterAvmClientModelsCommonCategory | null;
};
export type SprengnetterSprengConnectApiModelRequestBatchBatchUploadRequest = {
  /** Index ids for which the batch processing should be done */
  indices: ValuationHubCoreModelIndexType[] | null;
  /** Name of uploaded file */
  fileName: string | null;
  /** List of batch data for processing */
  batches: ValuationHubCoreModelCsvBatchInput[];
};
export type SprengnetterSprengConnectApiModelRequestBatchBatchProcessedRequest =
  {
    /** File name of batch csv output file located in AVM Blob Storage */
    fileName: string | null;
    /** Status of the batch processing on AVM side */
    status: ValuationHubCoreModelBatchStatus;
  };
export type AzureResponse601ValuationHubCoreModelDtoBatchOutputStatusDto = {};
export type ValuationHubCoreModelDtoBatchOutputStatusDto = {
  file_name?: string | null;
  status?: ValuationHubCoreModelBatchStatus;
};
export type AzureResponse601ValuationHubCoreModelDtoBatchOutputStatusDtoRead = {
  has_value?: boolean;
  value?: ValuationHubCoreModelDtoBatchOutputStatusDto | null;
};
export type AzureResponse601SystemCollectionsGenericList601ValuationHubCoreModelCsvBatchOutput =
  {};
export type ValuationHubCoreModelCsvIndexValues = {
  year?: number;
  quarter?: number | null;
  index?: number;
};
export type ValuationHubCoreModelCsvBatchOutput = {
  nation?: string | null;
  zip?: string | null;
  town?: string | null;
  category?: string | null;
  date?: string | null;
  error?: string | null;
  values?: ValuationHubCoreModelCsvIndexValues[] | null;
  index?: string | null;
  data_cut_off_date?: string | null;
};
export type AzureResponse601SystemCollectionsGenericList601ValuationHubCoreModelCsvBatchOutputRead =
  {
    has_value?: boolean;
    value?: ValuationHubCoreModelCsvBatchOutput[] | null;
  };
export type SprengnetterAvmClientModelsCommonAddress = {
  nation: SprengnetterAvmClientModelsCommonNation;
  street?: string | null;
  house_number?: string | null;
  zip?: string | null;
  town?: string | null;
};
export type SprengnetterAvmClientModelsCommonCoordinates = {
  lat: number;
  lng: number;
};
export type SprengnetterAvmClientModelsCommonLevel =
  | ""
  | "KEINE_ANGABE"
  | "SIMPLE"
  | "EINFACH"
  | "SIMPLE_MIDDLE"
  | "EINFACH_MITTEL"
  | "MIDDLE"
  | "MITTEL"
  | "MIDDLE_HIGH"
  | "MITTEL_GEHOBEN"
  | "HIGH"
  | "GEHOBEN"
  | "VERY_HIGH"
  | "STARK_GEHOBEN"
  | "HIGH_VERY_HIGH"
  | "GEHOBEN_STARK_GEHOBEN";
export type SprengnetterAvmClientModelsCommonDateAndPrice = {
  date?: string;
  value?: number;
};
export type SprengnetterAvmClientModelsResponsesCalculation = {
  address?: SprengnetterAvmClientModelsCommonAddress | null;
  coordinates?: SprengnetterAvmClientModelsCommonCoordinates | null;
  equipment?: SprengnetterAvmClientModelsCommonLevel | null;
  asking_price?: SprengnetterAvmClientModelsCommonDateAndPrice | null;
  transaction_price?: SprengnetterAvmClientModelsCommonDateAndPrice | null;
};
export type SprengnetterAvmValuationModelsResponsesValuationValueIpi = {
  year?: number;
  month?: number;
  quarter?: number;
  index?: number;
  value?: number;
  trend?: string | null;
  scale?: string | null;
  code?: string | null;
  region?: string | null;
};
export type SprengnetterAvmClientModelsResponsesRange = {
  min?: number;
  max?: number;
  probability?: number | null;
};
export type SprengnetterAvmClientModelsResponsesMeta = {
  model?: string | null;
  standarderror?: number | null;
  score?: number | null;
  range?: SprengnetterAvmClientModelsResponsesRange | null;
  time_series?: SprengnetterAvmClientModelsCommonDateAndPrice[] | null;
};
export type SprengnetterAvmValuationModelsResponsesValuationIpiResponse = {
  calc?: SprengnetterAvmClientModelsResponsesCalculation | null;
  date?: string;
  values?: SprengnetterAvmValuationModelsResponsesValuationValueIpi[] | null;
  meta?: SprengnetterAvmClientModelsResponsesMeta | null;
};
export type SprengnetterAvmClientModelsCommonAddressGeocoded = {
  nation: SprengnetterAvmClientModelsCommonNation;
  street?: string | null;
  house_number?: string | null;
  zip?: string | null;
  town?: string | null;
  lat: number;
  lng: number;
};
export type SprengnetterAvmClientModelsCommonRankStyle = 1 | 2;
export type SprengnetterAvmClientModelsCommonScale =
  | "BUNDESLAND"
  | "COUNTRY"
  | "BEZIRK"
  | "REGIERUNGSBEZIRK"
  | "REGION"
  | "KREIS"
  | "HISTORICAL_REGION"
  | "GEMEINDE"
  | "COUNTY"
  | "POSTLEITZAHLGEBIET"
  | "MUNICIPALITY"
  | "AUSWERTREGIONEN"
  | "NUTS3";
export type SprengnetterAvmValuationModelsRequestsValuationIpiRequest = {
  /** <p>
    Address object without coordinates.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address: SprengnetterAvmClientModelsCommonAddress;
  /** <p>
    Coordinates object for geolocation.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    If geolocation fails for the coordinates object then addres object (if passed) will be used for next geolocation call.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  coordinates: SprengnetterAvmClientModelsCommonCoordinates;
  /** <p>
    Object with both address data and coordinates.<br>
    It's assumed that the correct object data is provided, there will be no further geolocation lookup for this object.<br>
    If passed togather with address or coordinates those objects will be ignored and address_geocoded data will be used only.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address_geocoded: SprengnetterAvmClientModelsCommonAddressGeocoded;
  /** <p>
    Date of valuation. If specified this is the date for which the valuation is generated.<br>
    Default value is today.
    </p>
    Validation:
    <ul>
    <li>For 'nation': DE - From 2012-03-01 and now() + 1 year</li>
    <li>For 'nation': AT - From 2014-01-01 and now() + 1 year</li>
    </ul> */
  date?: string | null;
  /** <p>
    The type of the property.
    </p>
    Where:
    <ul>
    <li>ETW - Eigentumswohnung (Condominium)</li>
    <li>EFH - Einfamilienhaus (Single-family house)</li>
    <li>MFH - Mehrfamilienhaus (Multi-family house)</li>
    <li>GRD - Grundstueck (Plot)</li>
    </ul> */
  category: SprengnetterAvmClientModelsCommonCategory;
  /** <p>
    If set to true the result data will be returned per 4 months in a year, otherwise and by default the results are monthly.
    </p> */
  quarterly?: boolean | null;
  /** <p>
    If set to true the predicted values for next 2 years will be returned in a response.
    </p> */
  trend?: boolean | null;
  rank_style?: SprengnetterAvmClientModelsCommonRankStyle | null;
  /** <p>
    The scale (region) that should be used for valuation.
    </p>
    Validation:
    <ul>
    <li>For 'nation': DE - BUNDESLAND, REGIERUNGSBEZIRK, KREIS, GEMEINDE, POSTLEITZAHLGEBIET, AUSWERTREGIONEN</li>
    <li>For 'nation': AT - BUNDESLAND, BEZIRK, GEMEINDE</li>
    </ul> */
  scale?: SprengnetterAvmClientModelsCommonScale | null;
};
export type SprengnetterAvmRentModelsResponsesRentValueIpi = {
  year?: number;
  month?: number;
  quarter?: number;
  index?: number;
  value?: number;
  trend?: string | null;
  scale?: string | null;
  code?: string | null;
  region?: string | null;
};
export type SprengnetterAvmRentModelsResponsesRentIpiResponse = {
  calc?: SprengnetterAvmClientModelsResponsesCalculation | null;
  date?: string;
  values?: SprengnetterAvmRentModelsResponsesRentValueIpi[] | null;
  meta?: SprengnetterAvmClientModelsResponsesMeta | null;
};
export type SprengnetterAvmRentModelsRequestsRentIpiRequest = {
  /** <p>
    Address object without coordinates.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address: SprengnetterAvmClientModelsCommonAddress;
  /** <p>
    Coordinates object for geolocation.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    If geolocation fails for the coordinates object then addres object (if passed) will be used for next geolocation call.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  coordinates: SprengnetterAvmClientModelsCommonCoordinates;
  /** <p>
    Object with both address data and coordinates.<br>
    It's assumed that the correct object data is provided, there will be no further geolocation lookup for this object.<br>
    If passed togather with address or coordinates those objects will be ignored and address_geocoded data will be used only.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address_geocoded: SprengnetterAvmClientModelsCommonAddressGeocoded;
  /** <p>
    Date of valuation. If specified this is the date for which the valuation is generated.<br>
    Default value is today.
    </p>
    Validation:
    <ul>
    <li>For 'nation': DE - From 2012-03-01 and now() + 1 year</li>
    <li>For 'nation': AT - From 2014-01-01 and now() + 1 year</li>
    </ul> */
  date?: string | null;
  /** <p>
    The type of the property.
    </p>
    Where:
    <ul>
    <li>ETW - Eigentumswohnung (Condominium)</li>
    <li>EFH - Einfamilienhaus (Single-family house)</li>
    <li>MFH - Mehrfamilienhaus (Multi-family house)</li>
    <li>GRD - Grundstueck (Plot)</li>
    </ul> */
  category: SprengnetterAvmClientModelsCommonCategory;
  /** <p>
    If set to true the result data will be returned per 4 months in a year, otherwise and by default the results are monthly.
    </p> */
  quarterly?: boolean | null;
  /** <p>
    If set to true the predicted values for next 2 years will be returned in a response.
    </p> */
  trend?: boolean | null;
  rank_style?: SprengnetterAvmClientModelsCommonRankStyle | null;
  /** <p>
    The scale (region) that should be used for valuation.
    </p>
    Validation:
    <ul>
    <li>For 'nation': DE - BUNDESLAND, REGIERUNGSBEZIRK, KREIS, GEMEINDE, POSTLEITZAHLGEBIET, AUSWERTREGIONEN</li>
    <li>For 'nation': AT - BUNDESLAND, BEZIRK, GEMEINDE</li>
    </ul> */
  scale?: SprengnetterAvmClientModelsCommonScale | null;
};
export type SprengnetterAvmIndexModelsResponsesSimValue = {
  year?: number;
  index?: number;
  trend?: string | null;
  region?: string | null;
  code?: string | null;
  quarter?: number | null;
};
export type SprengnetterAvmIndexModelsResponsesSimResponse = {
  calc?: SprengnetterAvmClientModelsResponsesCalculation | null;
  date?: string;
  values?: SprengnetterAvmIndexModelsResponsesSimValue[] | null;
  meta?: SprengnetterAvmClientModelsResponsesMeta | null;
};
export type SprengnetterAvmIndexModelsRequestsSimRequest = {
  /** <p>
    Address object without coordinates.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address: SprengnetterAvmClientModelsCommonAddress;
  /** <p>
    Coordinates object for geolocation.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    If geolocation fails for the coordinates object then addres object (if passed) will be used for next geolocation call.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  coordinates: SprengnetterAvmClientModelsCommonCoordinates;
  /** <p>
    Object with both address data and coordinates.<br>
    It's assumed that the correct object data is provided, there will be no further geolocation lookup for this object.<br>
    If passed togather with address or coordinates those objects will be ignored and address_geocoded data will be used only.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address_geocoded: SprengnetterAvmClientModelsCommonAddressGeocoded;
  /** <p>
    Date of valuation. If specified this is the date for which the valuation is generated.<br>
    Default value is today.
    </p>
    Validation:
    <ul>
    <li>For 'nation': DE - From 2012-03-01 and now() + 1 year</li>
    <li>For 'nation': AT - From 2014-01-01 and now() + 1 year</li>
    </ul> */
  date?: string | null;
  /** <p>
    The type of the property.
    </p>
    Where:
    <ul>
    <li>ETW - Eigentumswohnung (Condominium)</li>
    <li>EFH - Einfamilienhaus (Single-family house)</li>
    <li>MFH - Mehrfamilienhaus (Multi-family house)</li>
    <li>GRD - Grundstueck (Plot)</li>
    </ul> */
  category: SprengnetterAvmClientModelsCommonCategory;
  from_year?: number | null;
  to_year?: number | null;
  scale?: SprengnetterAvmClientModelsCommonScale | null;
  /** <p>
    If set to true the result data will be returned per 4 months in a year, otherwise and by default the results are monthly.
    </p> */
  quarterly?: boolean;
};
export type SprengnetterAvmIndexModelsCommonSipnItem = {
  value_new?: number | null;
  value_existing?: number | null;
};
export type SprengnetterAvmIndexModelsCommonSipnValue = {
  year?: number;
  month?: number;
  quarter?: number;
  valuation?: SprengnetterAvmIndexModelsCommonSipnItem | null;
  rent?: SprengnetterAvmIndexModelsCommonSipnItem | null;
  gross_rental_yield?: SprengnetterAvmIndexModelsCommonSipnItem | null;
  payback_period?: SprengnetterAvmIndexModelsCommonSipnItem | null;
  trend?: number | null;
  scale?: string | null;
  region?: string | null;
  code?: string | null;
};
export type SprengnetterAvmIndexModelsResponsesSipnResponse = {
  calc?: SprengnetterAvmClientModelsResponsesCalculation | null;
  date?: string;
  values?: SprengnetterAvmIndexModelsCommonSipnValue[] | null;
  meta?: SprengnetterAvmClientModelsResponsesMeta | null;
};
export type SprengnetterAvmIndexModelsRequestsSipnRequest = {
  /** <p>
    Address object without coordinates.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address: SprengnetterAvmClientModelsCommonAddress;
  /** <p>
    Coordinates object for geolocation.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    If geolocation fails for the coordinates object then addres object (if passed) will be used for next geolocation call.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  coordinates: SprengnetterAvmClientModelsCommonCoordinates;
  /** <p>
    Object with both address data and coordinates.<br>
    It's assumed that the correct object data is provided, there will be no further geolocation lookup for this object.<br>
    If passed togather with address or coordinates those objects will be ignored and address_geocoded data will be used only.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address_geocoded: SprengnetterAvmClientModelsCommonAddressGeocoded;
  date?: string | null;
  trend?: boolean;
  /** <p>
    The scale (region) that should be used for index.
    </p>
    Validation:
    <ul>
    <li>BUNDESLAND, COUNTRY, BEZIRK, GEMEINDE, POSTLEITZAHLGEBIET</li>
    </ul> */
  scale?: SprengnetterAvmClientModelsCommonScale | null;
  /** <p>
    The type of the property.
    </p>
    Where:
    <ul>
    <li>ETW - Eigentumswohnung (Condominium)</li>
    <li>EFH - Einfamilienhaus (Single-family house)</li>
    <li>MFH - Mehrfamilienhaus (Multi-family house)</li>
    <li>GRD - Grundstueck (Plot)</li>
    </ul> */
  category: SprengnetterAvmClientModelsCommonCategory;
  rank_style?: SprengnetterAvmClientModelsCommonRankStyle;
};
export type SprengnetterAvmIndexModelsCommonSepiItem = {
  low?: number;
  medium?: number;
  top?: number;
};
export type SprengnetterAvmIndexModelsCommonAreaType =
  | "ALL"
  | "CITY"
  | "METROPOLITAN"
  | "RURAL";
export type SprengnetterAvmIndexModelsCommonSepiValue = {
  year?: number;
  month?: number;
  quarter?: number;
  energy_class?: SprengnetterAvmIndexModelsCommonSepiItem | null;
  region?: string | null;
  area_type?: SprengnetterAvmIndexModelsCommonAreaType | null;
};
export type SprengnetterAvmIndexModelsResponsesSepiResponse = {
  calc?: SprengnetterAvmClientModelsResponsesCalculation | null;
  date?: string;
  values?: SprengnetterAvmIndexModelsCommonSepiValue[] | null;
  meta?: SprengnetterAvmClientModelsResponsesMeta | null;
};
export type SprengnetterAvmIndexModelsRequestsSepiRequest = {
  /** <p>
    Address object without coordinates.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address: SprengnetterAvmClientModelsCommonAddress;
  /** <p>
    Coordinates object for geolocation.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    If geolocation fails for the coordinates object then addres object (if passed) will be used for next geolocation call.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  coordinates: SprengnetterAvmClientModelsCommonCoordinates;
  /** <p>
    Object with both address data and coordinates.<br>
    It's assumed that the correct object data is provided, there will be no further geolocation lookup for this object.<br>
    If passed togather with address or coordinates those objects will be ignored and address_geocoded data will be used only.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address_geocoded: SprengnetterAvmClientModelsCommonAddressGeocoded;
  date?: string | null;
  /** <p>
    The type of the property.
    </p>
    Where:
    <ul>
    <li>ETW - Eigentumswohnung (Condominium)</li>
    <li>EFH - Einfamilienhaus (Single-family house)</li>
    <li>MFH - Mehrfamilienhaus (Multi-family house)</li>
    <li>GRD - Grundstueck (Plot)</li>
    </ul> */
  category: SprengnetterAvmClientModelsCommonCategory;
  area_type?: SprengnetterAvmIndexModelsCommonAreaType | null;
  /** <p>
    The scale (region) that should be used for index.
    </p>
    Validation:
    <ul>
    <li>BUNDESLAND, COUNTRY, BEZIRK, GEMEINDE, POSTLEITZAHLGEBIET</li>
    </ul> */
  scale?: SprengnetterAvmClientModelsCommonScale | null;
};
export type SprengnetterAvmValuationModelsRequestsValuationValueAipi = {
  year?: number;
  month?: number;
  quarter?: number;
  index_offer?: number;
  index_transaction?: number;
  value?: number;
  scale?: string | null;
  code?: string | null;
  region?: string | null;
};
export type SprengnetterAvmValuationModelsResponsesValuationAipiResponse = {
  calc?: SprengnetterAvmClientModelsResponsesCalculation | null;
  date?: string;
  values?: SprengnetterAvmValuationModelsRequestsValuationValueAipi[] | null;
  meta?: SprengnetterAvmClientModelsResponsesMeta | null;
};
export type SprengnetterAvmValuationModelsRequestsValuationAipiRequest = {
  /** <p>
    Address object without coordinates.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address: SprengnetterAvmClientModelsCommonAddress;
  /** <p>
    Coordinates object for geolocation.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    If geolocation fails for the coordinates object then addres object (if passed) will be used for next geolocation call.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  coordinates: SprengnetterAvmClientModelsCommonCoordinates;
  /** <p>
    Object with both address data and coordinates.<br>
    It's assumed that the correct object data is provided, there will be no further geolocation lookup for this object.<br>
    If passed togather with address or coordinates those objects will be ignored and address_geocoded data will be used only.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address_geocoded: SprengnetterAvmClientModelsCommonAddressGeocoded;
  date?: string | null;
  category: SprengnetterAvmClientModelsCommonCategory;
  quarterly?: boolean;
  rank_style?: SprengnetterAvmClientModelsCommonRankStyle;
  scale?: SprengnetterAvmClientModelsCommonScale;
};
export type SprengnetterAvmDemandScoreModelsResponsesDemandScore =
  | "VERY_LOW_DEMAND"
  | "LOW_DEMAND"
  | "MODERATE_DEMAND"
  | "HIGH_DEMAND"
  | "VERY_HIGH_DEMAND";
export type SprengnetterAvmDemandScoreModelsResponsesDemandScoreResponse = {
  calc?: SprengnetterAvmClientModelsResponsesCalculation | null;
  value?: number;
  stars?: number;
  demandscore_class?: SprengnetterAvmDemandScoreModelsResponsesDemandScore;
  date?: string;
  meta?: SprengnetterAvmClientModelsResponsesMeta | null;
};
export type SprengnetterAvmDemandScoreModelsRequestsDemandValuationType = 0 | 1;
export type SprengnetterAvmDemandScoreModelsRequestsDemandScoreRequest = {
  /** <p>
    Address object without coordinates.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address: SprengnetterAvmClientModelsCommonAddress;
  /** <p>
    Coordinates object for geolocation.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    If geolocation fails for the coordinates object then addres object (if passed) will be used for next geolocation call.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  coordinates: SprengnetterAvmClientModelsCommonCoordinates;
  /** <p>
    Object with both address data and coordinates.<br>
    It's assumed that the correct object data is provided, there will be no further geolocation lookup for this object.<br>
    If passed togather with address or coordinates those objects will be ignored and address_geocoded data will be used only.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address_geocoded: SprengnetterAvmClientModelsCommonAddressGeocoded;
  /** <p>
    The type of the property.
    </p>
    Where:
    <ul>
    <li>ETW - Eigentumswohnung (Condominium)</li>
    <li>EFH - Einfamilienhaus (Single-family house)</li>
    <li>MFH - Mehrfamilienhaus (Multi-family house)</li>
    <li>GRD - Grundstueck (Plot)</li>
    </ul> */
  category: SprengnetterAvmClientModelsCommonCategory;
  construction_year?: number | null;
  /** <p>
    Size of the living area of a property.<br>
    Unit: square meter
    </p>
    Validation:
    <ul>
    <li>For 'category': ETW - from 1 to 500</li>
    <li>For 'category': EFH - from 1 to 1000</li>
    <li>For 'category': MFH - from 1 to 2000</li>
    </ul> */
  living_area?: number | null;
  /** <p>
    Size of the plot area of a property.<br>
    Unit: square meter
    </p> */
  plot_area?: number | null;
  rooms?: number | null;
  /** <p>
    Floor on which the property is located. This is relevant only for categories: ETW.
    </p> */
  floor?: number | null;
  /** <p>
    Requests if the property is rented or not.
    </p> */
  rented?: boolean | null;
};
export type SprengnetterAvmIndexModelsResponsesCrr3Value = {
  year?: number;
  crr3_risk_discount?: number;
  region?: string | null;
  quarter?: number;
  sim_effective_date?: string;
  meta_text?: string | null;
};
export type SprengnetterAvmIndexModelsResponsesCrr3Response = {
  calc?: SprengnetterAvmClientModelsResponsesCalculation | null;
  date?: string;
  values?: SprengnetterAvmIndexModelsResponsesCrr3Value[] | null;
  meta?: SprengnetterAvmClientModelsResponsesMeta | null;
};
export type SprengnetterAvmIndexModelsRequestsCrr3Request = {
  /** <p>
    Address object without coordinates.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address: SprengnetterAvmClientModelsCommonAddress;
  /** <p>
    Coordinates object for geolocation.<br>
    If passed without address_geocoded this data will be passed to geolocation service to determine correct full address.<br>
    If geolocation fails for the coordinates object then addres object (if passed) will be used for next geolocation call.<br>
    In case address_geocoded is passed this data will be ignored.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  coordinates: SprengnetterAvmClientModelsCommonCoordinates;
  /** <p>
    Object with both address data and coordinates.<br>
    It's assumed that the correct object data is provided, there will be no further geolocation lookup for this object.<br>
    If passed togather with address or coordinates those objects will be ignored and address_geocoded data will be used only.<br>
    Only one of address, coordinates and address_geocoded fields is required.
    </p> */
  address_geocoded: SprengnetterAvmClientModelsCommonAddressGeocoded;
  /** <p>
    Date of valuation. If specified this is the date for which the valuation is generated.<br>
    Default value is today.
    </p>
    Validation:
    <ul>
    <li>For 'nation': DE - From 2012-03-01 and now() + 1 year</li>
    <li>For 'nation': AT - From 2014-01-01 and now() + 1 year</li>
    </ul> */
  date?: string | null;
  /** <p>
    The type of the property.
    </p>
    Where:
    <ul>
    <li>ETW - Eigentumswohnung (Condominium)</li>
    <li>EFH - Einfamilienhaus (Single-family house)</li>
    <li>MFH - Mehrfamilienhaus (Multi-family house)</li>
    </ul> */
  category: SprengnetterAvmClientModelsCommonCategory;
  from_year: number;
  to_year: number;
  /** <p>
    The scale (region) that should be used for index.
    </p>
    Validation:
    <ul>
    <li>BUNDESLAND, COUNTRY, POSTLEITZAHLGEBIET</li>
    </ul> */
  scale?: SprengnetterAvmClientModelsCommonScale | null;
};
export type ValuationHubCoreModelDocumentType = 0 | 1 | 2 | 3;
export type SprengnetterValuationHubValuationPackageModelResponseInstitutionUserListItemResponse =
  {
    id: string | null;
    display_name: string | null;
    email_address: string | null;
    role?: ValuationHubCoreModelRole | null;
    can_view_institution_valuations?: boolean;
  };
export type ValuationHubCoreCommonPaginatedResponse601SprengnetterValuationHubValuationPackageModelResponseInstitutionUserListItemResponse =
  {
    data?:
      | SprengnetterValuationHubValuationPackageModelResponseInstitutionUserListItemResponse[]
      | null;
    pagination?: ValuationHubCoreCommonMetaPagination | null;
  };
export type SprengnetterSprengConnectApiModelResponseErrorResponse = {
  errors?:
    | {
        [key: string]: string;
      }[]
    | null;
  error_code?: string | null;
};
export type AzureResponse601SprengnetterValuationHubApiModelResponseInstitutionProfileSettingsResponse =
  {};
export type SprengnetterValuationHubApiModelResponseInstitutionProfileSettingsResponse =
  {
    company_name?: string | null;
    house_number?: string | null;
    street?: string | null;
    town?: string | null;
    post_code?: string | null;
    website?: string | null;
    primary_color?: string | null;
    company_logo_url?: string | null;
  };
export type AzureResponse601SprengnetterValuationHubApiModelResponseInstitutionProfileSettingsResponseRead =
  {
    has_value?: boolean;
    value?: SprengnetterValuationHubApiModelResponseInstitutionProfileSettingsResponse | null;
  };
export type SprengnetterValuationHubApiModelRequestInstitutionProfileSettingsRequest =
  {
    company_name?: string | null;
    house_number?: string | null;
    street?: string | null;
    town?: string | null;
    post_code?: string | null;
    website?: string | null;
    primary_color?: string | null;
    company_logo?: string | null;
  };
export type SprengnetterValuationHubOneClickModelResponseSoneResponse = {
  id?: string;
  marketvalue?: number | null;
  marketvalue_sqm?: number | null;
  lendingvalue?: number | null;
  lendingvalue_sqm?: number | null;
  lendingvalue_nwp?: number | null;
};
export type SprengnetterValuationHubSoneModelCommonProductType =
  | "MarketValue"
  | "LendingValue";
export type ValuationHubCoreModelRealEstateAddressCoordinate = {
  lat: number;
  lng: number;
};
export type ValuationHubCoreModelRealEstateAddress = {
  nation: string | null;
  town?: string | null;
  street?: string | null;
  house_number?: string | null;
  post_code?: string | null;
  coordinates?: ValuationHubCoreModelRealEstateAddressCoordinate | null;
};
export type ValuationHubCoreModelRealEstateEnumsObjectType =
  | "HOUSE"
  | "APARTMENT"
  | "MULTI_FAMILY_HOUSE"
  | "PLOT_OF_LAND"
  | "MIXED_USE_PROPERTY";
export type ValuationHubCoreModelRealEstateEnumsBuildingType =
  | "SINGLE_FAMILY_HOUSE"
  | "SINGLE_FAMILY_HOUSE_WITH_GRANNY_APARTMENT"
  | "TWO_FAMILY_HOUSE"
  | "APARTMENT"
  | "MULTI_FAMILY_HOUSE"
  | "PLOT_AREA"
  | "MIXED_USE_PROPERTY";
export type ValuationHubCoreModelRealEstateEnumsHouseApartmentType =
  | "DETACHED_HOUSE"
  | "SEMI_DETACHED_HOUSE"
  | "END_TERRACED_HOUSE"
  | "MID_TERRACED_HOUSE"
  | "LOFT"
  | "PENTHOUSE"
  | "BASEMENT_APARTMENT"
  | "GROUND_FLOOR_APARTMENT"
  | "MID_FLOOR_APARTMENT"
  | "RAISED_FIRST_FLOOR_APARTMENT"
  | "TWO_FLOOR_APARTMENT"
  | "TERRACED_APARTMENT"
  | "ATTIC_APARTMENT"
  | "ATTIC_PENTHOUSE"
  | "APARTMENT_WITH_GARDEN";
export type ValuationHubCoreModelRealEstateEnumsOwnership =
  | "FULL"
  | "LEASE"
  | "SHARED"
  | "SHARED_LEASE";
export type ValuationHubCoreModelRealEstateEnumsBasement =
  | "FULL"
  | "PARTIAL"
  | "NONE";
export type ValuationHubCoreModelRealEstateEnumsBasementConversion =
  | "FULL"
  | "PARTIAL"
  | "NONE";
export type ValuationHubCoreModelRealEstateEnumsConstruction =
  | "MASSIVE"
  | "PREFABRICATED_MASSIVE_HOUSE"
  | "PREFABRICATED_WOOD_HOUSE";
export type ValuationHubCoreModelRealEstateEnumsRoof =
  | "FULLY_DEVELOPED"
  | "PARTIALLY_DEVELOPED"
  | "NOT_DEVELOPED"
  | "FLAT";
export type ValuationHubCoreModelRealEstateEnumsOutdoorFacilities =
  | "NONE"
  | "BELOW_AVERAGE"
  | "AVERAGE"
  | "ABOVE_AVERAGE";
export type ValuationHubCoreModelRealEstateEnumsEquipmentMethod =
  | "SIMPLE"
  | "DETAILED"
  | "AUTOMATIC";
export type ValuationHubCoreModelRealEstateEnumsEquipmentValue =
  | "VERY_SIMPLE"
  | "SIMPLE"
  | "SIMPLE_TO_MEDIUM"
  | "MEDIUM"
  | "MEDIUM_TO_HIGH"
  | "HIGH"
  | "HIGH_TO_VERY_HIGH"
  | "VERY_HIGH"
  | "VERY_VERY_HIGH";
export type ValuationHubCoreModelRealEstateEnumsEquipmentMatrixBathroom =
  | "INSIDE"
  | "MORE_THAN_ONE_BATH"
  | "WITH_WINDOW"
  | "ONE_BATH";
export type ValuationHubCoreModelRealEstateEnumsEquipmentMatrixRoofCovering =
  | "ROOFING_FELT"
  | "ROOFING_TILES"
  | "METAL"
  | "SLATE"
  | "OTHER";
export type ValuationHubCoreModelRealEstateEnumsEquipmentMatrixWindows =
  | "DOUBLE_GLAZING"
  | "TRIPLE_GLAZING"
  | "SPECIAL_GLAZING"
  | "FLOOR_TO_CEILING_GLAZING"
  | "BOX_WINDOW"
  | "SIMPLE"
  | "OTHER";
export type ValuationHubCoreModelRealEstateEnumsEquipmentMatrixHeating =
  | "FLOOR_HEATING"
  | "STOVES_HEATING"
  | "CENTRAL_HEATING"
  | "OTHER";
export type ValuationHubCoreModelRealEstateEnumsEquipmentMatrixSurfaceMountedInstallation =
  "CABLES_ON_WALLS" | "CABLES_NOT_ON_WALLS";
export type ValuationHubCoreModelRealEstateEnumsEquipmentMatrixStoreRoom =
  | "OUTSIDE"
  | "INSIDE"
  | "OUTSIDE_AND_INSIDE"
  | "NONE";
export type ValuationHubCoreModelRealEstateEnumsEquipmentMatrixFloorCovering =
  | "TILES"
  | "PLASTIC_PVC"
  | "PARQUET_NATURAL_STONE"
  | "CARPET_LAMINATE"
  | "OTHER";
export type ValuationHubCoreModelRealEstateEnumsEquipmentMatrixResidentialArea =
  "WINTER_GARDEN" | "BALCONY_ABOVE_10" | "BALCONY_UNDER_10" | "NO_BALCONY";
export type ValuationHubCoreModelRealEstateEquipmentMatrix = {
  insulated_exterior_walls?: boolean | null;
  bathroom?: ValuationHubCoreModelRealEstateEnumsEquipmentMatrixBathroom | null;
  roof_covering?: ValuationHubCoreModelRealEstateEnumsEquipmentMatrixRoofCovering | null;
  windows?: ValuationHubCoreModelRealEstateEnumsEquipmentMatrixWindows | null;
  guest_toilet?: boolean | null;
  heating?: ValuationHubCoreModelRealEstateEnumsEquipmentMatrixHeating | null;
  heating_system?: boolean | null;
  surface_mounted_installation?: ValuationHubCoreModelRealEstateEnumsEquipmentMatrixSurfaceMountedInstallation | null;
  store_room?: ValuationHubCoreModelRealEstateEnumsEquipmentMatrixStoreRoom | null;
  floor_covering?: ValuationHubCoreModelRealEstateEnumsEquipmentMatrixFloorCovering | null;
  residential_area?: ValuationHubCoreModelRealEstateEnumsEquipmentMatrixResidentialArea | null;
  sauna?: boolean | null;
  fireplace?: boolean | null;
};
export type ValuationHubCoreModelRealEstateEquipment = {
  method?: ValuationHubCoreModelRealEstateEnumsEquipmentMethod | null;
  value?: ValuationHubCoreModelRealEstateEnumsEquipmentValue | null;
  matrix?: ValuationHubCoreModelRealEstateEquipmentMatrix | null;
};
export type ValuationHubCoreModelRealEstateEnumsModernizationMethod =
  | "SIMPLE"
  | "DETAILED"
  | "AUTOMATIC"
  | "COSTS";
export type ValuationHubCoreModelRealEstateEnumsModernizationClass =
  | "NONE"
  | "LIGHT"
  | "MEDIUM"
  | "MOST"
  | "FULL";
export type ValuationHubCoreModelRealEstateEnumsModernizationLevel =
  | "NONE"
  | "PARTIAL"
  | "FULL";
export type ValuationHubCoreModelRealEstateModernizationMatrix = {
  interior_design?: ValuationHubCoreModelRealEstateEnumsModernizationLevel | null;
  sanitary_area?: ValuationHubCoreModelRealEstateEnumsModernizationLevel | null;
  heating_system?: ValuationHubCoreModelRealEstateEnumsModernizationLevel | null;
  pipes?: ValuationHubCoreModelRealEstateEnumsModernizationLevel | null;
  windows?: ValuationHubCoreModelRealEstateEnumsModernizationLevel | null;
  thermal_insulation?: ValuationHubCoreModelRealEstateEnumsModernizationLevel | null;
  roof_covering_and_insulation?: ValuationHubCoreModelRealEstateEnumsModernizationLevel | null;
  room_layout?: ValuationHubCoreModelRealEstateEnumsModernizationLevel | null;
};
export type ValuationHubCoreModelRealEstateModernization = {
  method?: ValuationHubCoreModelRealEstateEnumsModernizationMethod | null;
  class?: ValuationHubCoreModelRealEstateEnumsModernizationClass | null;
  cost?: number | null;
  cost_description?: string | null;
  refurbishment_year?: number | null;
  matrix?: ValuationHubCoreModelRealEstateModernizationMatrix | null;
};
export type ValuationHubCoreModelRealEstateEnumsEnergyEfficiencyHouseStandard =
  | "KFW_40"
  | "KFW_40_PLUS"
  | "KFW_55"
  | "KFW_55_REF_VAL"
  | "KFW_70"
  | "KFW_85"
  | "KFW_100"
  | "KFW_115"
  | "KFW_HISTORICAL_BUILDING"
  | "PASSIVE";
export type ValuationHubCoreModelRealEstateEnumsEnergyClass =
  | "A_PLUS"
  | "A"
  | "B"
  | "C"
  | "D"
  | "E"
  | "F"
  | "G"
  | "H";
export type ValuationHubCoreModelRealEstateEnumsEnergyCertificateType =
  | "DEMAND"
  | "CONSUMPTION";
export type ValuationHubCoreModelRealEstateEnergyCertificate = {
  energy_class?: ValuationHubCoreModelRealEstateEnumsEnergyClass | null;
  issue_date?: string | null;
  certificate_type?: ValuationHubCoreModelRealEstateEnumsEnergyCertificateType | null;
  final_energy_demand?: number | null;
  primary_energy_demand?: number | null;
  co2_emission?: number | null;
};
export type ValuationHubCoreModelRealEstatePhotovoltaicInformation = {
  construction_year?: number | null;
  annual_power_yield?: number | null;
};
export type ValuationHubCoreModelRealEstatePropertyInformation = {
  object_type: ValuationHubCoreModelRealEstateEnumsObjectType;
  building_type?: ValuationHubCoreModelRealEstateEnumsBuildingType | null;
  house_or_apartment_type?: ValuationHubCoreModelRealEstateEnumsHouseApartmentType | null;
  ownership?: ValuationHubCoreModelRealEstateEnumsOwnership | null;
  construction_year?: number | null;
  living_area?: number | null;
  commercial_area?: number | null;
  plot_area?: number | null;
  number_of_floors?: number | null;
  floor_number?: number | null;
  rooms?: number | null;
  basement?: ValuationHubCoreModelRealEstateEnumsBasement | null;
  basement_conversion?: ValuationHubCoreModelRealEstateEnumsBasementConversion | null;
  construction?: ValuationHubCoreModelRealEstateEnumsConstruction | null;
  garages?: number | null;
  outdoor_parking_spaces?: number | null;
  elevator?: boolean | null;
  number_of_units?: number | null;
  commercial_units?: number | null;
  roof?: ValuationHubCoreModelRealEstateEnumsRoof | null;
  outdoor_facilities?: ValuationHubCoreModelRealEstateEnumsOutdoorFacilities | null;
  garden?: boolean | null;
  equipment?: ValuationHubCoreModelRealEstateEquipment | null;
  modernization?: ValuationHubCoreModelRealEstateModernization | null;
  energy_efficiency_house_standard?: ValuationHubCoreModelRealEstateEnumsEnergyEfficiencyHouseStandard | null;
  energy_certificate?: ValuationHubCoreModelRealEstateEnergyCertificate | null;
  photovoltaic?: ValuationHubCoreModelRealEstatePhotovoltaicInformation | null;
};
export type ValuationHubCoreModelRealEstateEnumsPriceType = "PURCHASE";
export type ValuationHubCoreModelRealEstatePrice = {
  value?: number | null;
  type?: ValuationHubCoreModelRealEstateEnumsPriceType | null;
};
export type ValuationHubCoreModelRealEstateEnumsRentReference =
  | "EURO_PER_SQUARE_METER"
  | "EURO_PER_YEAR";
export type ValuationHubCoreModelRealEstateRent = {
  value?: number | null;
  reference?: ValuationHubCoreModelRealEstateEnumsRentReference | null;
};
export type ValuationHubCoreModelRealEstateFinancialInformation = {
  price?: ValuationHubCoreModelRealEstatePrice | null;
  rent?: ValuationHubCoreModelRealEstateRent | null;
};
export type ValuationHubCoreModelRealEstateEnumsRentalCurrentUsage =
  | "OWNER_OCCUPIED"
  | "RENTED"
  | "PARTIALLY_OWNER_OCCUPIED";
export type ValuationHubCoreModelRealEstateRentalInformation = {
  current_usage?: ValuationHubCoreModelRealEstateEnumsRentalCurrentUsage | null;
  suitable_for_own_use?: boolean | null;
};
export type ValuationHubCoreModelRealEstateAvmEquipmentPriceRange = {
  equipment?: string | null;
  value?: number | null;
  min?: number | null;
  max?: number | null;
};
export type ValuationHubCoreModelRealEstateMixedUseFactorValueInput = {
  value?: number | null;
};
export type ValuationHubCoreModelRealEstateMixedUseFactorInput = {
  residential?: ValuationHubCoreModelRealEstateMixedUseFactorValueInput | null;
  commercial?: ValuationHubCoreModelRealEstateMixedUseFactorValueInput | null;
};
export type ValuationHubCoreModelRealEstateMixedUseFactorsInput = {
  property_yield_rate?: ValuationHubCoreModelRealEstateMixedUseFactorInput | null;
  comparable_rent?: ValuationHubCoreModelRealEstateMixedUseFactorInput | null;
};
export type ValuationHubCoreModelRealEstateProsaWebFactorsInput = {
  asset_value_factor?: number | null;
  building_price_index?: number | null;
  regional_factor?: number | null;
  property_yield_rate?: number | null;
  mixed_use_factors?: ValuationHubCoreModelRealEstateMixedUseFactorsInput | null;
  comparable_price?: number | null;
  comparable_rent?: number | null;
  standard_ground_value?: number | null;
  market_adjustment_per_m2?: number | null;
};
export type ValuationHubCoreModelRealEstateValuationHubRealEstate = {
  address: ValuationHubCoreModelRealEstateAddress | null;
  property_information: ValuationHubCoreModelRealEstatePropertyInformation | null;
  financial_information?: ValuationHubCoreModelRealEstateFinancialInformation | null;
  rental_information?: ValuationHubCoreModelRealEstateRentalInformation | null;
  equipment_price_range?:
    | ValuationHubCoreModelRealEstateAvmEquipmentPriceRange[]
    | null;
  selected_equipment_price_range?: ValuationHubCoreModelRealEstateAvmEquipmentPriceRange | null;
  factors?: ValuationHubCoreModelRealEstateProsaWebFactorsInput | null;
};
export type SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601ValuationHubCoreModelRealEstateEnumsHouseApartmentType =
  {
    value?: ValuationHubCoreModelRealEstateEnumsHouseApartmentType;
    provider?: string | null;
  };
export type SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601SystemDecimal =
  {
    value?: number;
    provider?: string | null;
  };
export type SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601SystemInt32 =
  {
    value?: number;
    provider?: string | null;
  };
export type SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601ValuationHubCoreModelRealEstateEnumsConstruction =
  {
    value?: ValuationHubCoreModelRealEstateEnumsConstruction;
    provider?: string | null;
  };
export type SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601ValuationHubCoreModelRealEstateEnumsBasement =
  {
    value?: ValuationHubCoreModelRealEstateEnumsBasement;
    provider?: string | null;
  };
export type SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601ValuationHubCoreModelRealEstateEnumsEnergyEfficiencyHouseStandard =
  {
    value?: ValuationHubCoreModelRealEstateEnumsEnergyEfficiencyHouseStandard;
    provider?: string | null;
  };
export type SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601ValuationHubCoreModelRealEstateEnumsEquipmentMatrixBathroom =
  {
    value?: ValuationHubCoreModelRealEstateEnumsEquipmentMatrixBathroom;
    provider?: string | null;
  };
export type SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseEquipmentResponseEquipmentMatrix =
  {
    bathroom?:
      | SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601ValuationHubCoreModelRealEstateEnumsEquipmentMatrixBathroom[]
      | null;
  };
export type SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseEquipmentResponse =
  {
    matrix: SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseEquipmentResponseEquipmentMatrix | null;
  };
export type SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601ValuationHubCoreModelRealEstateEnumsEnergyClass =
  {
    value?: ValuationHubCoreModelRealEstateEnumsEnergyClass;
    provider?: string | null;
  };
export type SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601ValuationHubCoreModelRealEstateEnumsEnergyCertificateType =
  {
    value?: ValuationHubCoreModelRealEstateEnumsEnergyCertificateType;
    provider?: string | null;
  };
export type SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseEnergyCertificateResponse =
  {
    energy_class?:
      | SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601ValuationHubCoreModelRealEstateEnumsEnergyClass[]
      | null;
    certificate_type?:
      | SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601ValuationHubCoreModelRealEstateEnumsEnergyCertificateType[]
      | null;
    final_energy_demand?:
      | SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601SystemDecimal[]
      | null;
    primary_energy_demand?:
      | SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601SystemDecimal[]
      | null;
    co2_emission?:
      | SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601SystemDecimal[]
      | null;
  };
export type SprengnetterValuationHubOneClickModelResponseObjectPlatformResponse =
  {
    object_type: ValuationHubCoreModelRealEstateEnumsObjectType;
    building_type: ValuationHubCoreModelRealEstateEnumsBuildingType;
    house_or_apartment_type?:
      | SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601ValuationHubCoreModelRealEstateEnumsHouseApartmentType[]
      | null;
    plot_area?:
      | SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601SystemDecimal[]
      | null;
    living_area?:
      | SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601SystemDecimal[]
      | null;
    construction_year?:
      | SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601SystemInt32[]
      | null;
    construction?:
      | SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601ValuationHubCoreModelRealEstateEnumsConstruction[]
      | null;
    number_of_floors?:
      | SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601SystemInt32[]
      | null;
    basement?:
      | SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601ValuationHubCoreModelRealEstateEnumsBasement[]
      | null;
    energy_efficiency_house_standard?:
      | SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseProviderValue601ValuationHubCoreModelRealEstateEnumsEnergyEfficiencyHouseStandard[]
      | null;
    equipment?: SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseEquipmentResponse | null;
    energy_certificate?: SprengnetterValuationHubOneClickModelResponseObjectPlatformResponseEnergyCertificateResponse | null;
  };
export type SprengnetterValuationHubOneClickModelRequestObjectPlatformRequest =
  {
    address: ValuationHubCoreModelRealEstateAddress | null;
    object_type: ValuationHubCoreModelRealEstateEnumsObjectType;
  };
export type SprengnetterValuationHubOutlierShieldModelCommonPlausibilityCheckAssessment =

    | "MOST_PROBABLY_NOT_OKAY"
    | "MOST_PROBABLY_OKAY"
    | "NOT_OKAY"
    | "OKAY"
    | "NO_VALID_DATA";
export type SprengnetterValuationHubOutlierShieldModelCommonPriceIndicator =
  | "EQUAL"
  | "HIGHER"
  | "LOWER";
export type SprengnetterValuationHubOutlierShieldModelResponsePlausibilityCheckResponsePlausibilityCheckResult =
  {
    market_price: number;
    assessment: SprengnetterValuationHubOutlierShieldModelCommonPlausibilityCheckAssessment;
    price_indicator?: SprengnetterValuationHubOutlierShieldModelCommonPriceIndicator | null;
  };
export type SprengnetterValuationHubOutlierShieldModelResponsePlausibilityCheckResponse =
  {
    real_estate: ValuationHubCoreModelRealEstateValuationHubRealEstate | null;
    result: SprengnetterValuationHubOutlierShieldModelResponsePlausibilityCheckResponsePlausibilityCheckResult | null;
  };
export type SprengnetterValuationHubApiModelResponseProtocolValuationPackageSubscriptionStatus =
  "INACTIVE" | "ACTIVE" | "EXPIRED";
export type SprengnetterValuationHubApiModelResponseProtocolProtocolDataValuationPackageResponse =
  {
    booked_valuations_count?: number;
    used_valuations_count?: number;
    subscription_status?: SprengnetterValuationHubApiModelResponseProtocolValuationPackageSubscriptionStatus;
  };
export type ValuationHubCoreModelDtoValuationPackageItemCreatedAtDto = {
  created_at: string;
};
export type SprengnetterValuationHubApiModelResponseProtocolProtocolDataReportDownloadResponse =
  {
    timestamp: string;
    format: string | null;
  };
export type SprengnetterValuationHubApiModelResponseProtocolProtocolDataUserListResponse =
  {
    user_id: string | null;
    user_name: string | null;
    email: string | null;
    roles: string[] | null;
    status: ValuationHubCoreModelAccountStatus;
    institution_id: number;
    partner_name: string | null;
    valuation_result?:
      | ValuationHubCoreModelDtoValuationPackageItemCreatedAtDto[]
      | null;
    report_downloads?:
      | SprengnetterValuationHubApiModelResponseProtocolProtocolDataReportDownloadResponse[]
      | null;
  };
export type SprengnetterValuationHubApiModelResponseProtocolProtocolDataInstitutionListResponse =
  {
    institution_id: number;
    institution_name: string | null;
    active_products: string[] | null;
    valuation_package: SprengnetterValuationHubApiModelResponseProtocolProtocolDataValuationPackageResponse | null;
    users:
      | SprengnetterValuationHubApiModelResponseProtocolProtocolDataUserListResponse[]
      | null;
  };
export type ValuationHubCoreCommonPaginatedResponse601SprengnetterValuationHubApiModelResponseProtocolProtocolDataInstitutionListResponse =
  {
    data?:
      | SprengnetterValuationHubApiModelResponseProtocolProtocolDataInstitutionListResponse[]
      | null;
    pagination?: ValuationHubCoreCommonMetaPagination | null;
  };
export type AzureResponse601ValuationHubCoreModelDtoUserPermissionsResponse =
  {};
export type ValuationHubCoreModelDtoModulePermission = {
  available: boolean;
};
export type ValuationHubCoreModelDtoUserPermissionsResponse = {
  index: {
    SIPI?: ValuationHubCoreModelFeatureType[];
    SIPN?: ValuationHubCoreModelFeatureType[];
    SIM?: ValuationHubCoreModelFeatureType[];
    SEPI?: ValuationHubCoreModelFeatureType[];
    VALUATION_AIPI?: ValuationHubCoreModelFeatureType[];
    CRR3_RISK_DISCOUNT?: ValuationHubCoreModelFeatureType[];
  } | null;
  ONECLICK: ValuationHubCoreModelDtoModulePermission | null;
  OUTLIERSHIELD: ValuationHubCoreModelDtoModulePermission | null;
  VALUATIONSPACKAGE: ValuationHubCoreModelDtoModulePermission | null;
  ADMIN: boolean;
  INSTITUTION_ADMIN: boolean;
};
export type AzureResponse601ValuationHubCoreModelDtoUserPermissionsResponseRead =
  {
    has_value?: boolean;
    value?: ValuationHubCoreModelDtoUserPermissionsResponse | null;
  };
export type AzureResponse601SprengnetterValuationHubApiModelResponseUserProfileSettingsResponse =
  {};
export type SprengnetterValuationHubApiModelResponseUserContactInformationResponse =
  {
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
    phone_number?: string | null;
    profile_picture_url?: string | null;
  };
export type SprengnetterValuationHubApiModelResponseUserProfileSettingsResponse =
  {
    contact_information?: SprengnetterValuationHubApiModelResponseUserContactInformationResponse | null;
    company_information?: SprengnetterValuationHubApiModelResponseInstitutionProfileSettingsResponse | null;
    override_company_information?: boolean | null;
  };
export type AzureResponse601SprengnetterValuationHubApiModelResponseUserProfileSettingsResponseRead =
  {
    has_value?: boolean;
    value?: SprengnetterValuationHubApiModelResponseUserProfileSettingsResponse | null;
  };
export type SprengnetterValuationHubApiModelRequestUserContactInformationRequest =
  {
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
    phone_number?: string | null;
    profile_picture?: string | null;
  };
export type SprengnetterValuationHubApiModelRequestUserProfileSettingsRequest =
  {
    contact_information?: SprengnetterValuationHubApiModelRequestUserContactInformationRequest | null;
    company_information?: SprengnetterValuationHubApiModelRequestInstitutionProfileSettingsRequest | null;
    override_company_information?: boolean | null;
  };
export type AzureResponse601SprengnetterValuationHubApiModelResponseUserProfileResponse =
  {};
export type SprengnetterValuationHubApiModelResponseUserProfileResponse = {
  company_logo_url?: string | null;
  profile_picture_url?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone_number?: string | null;
  company_name?: string | null;
  house_number?: string | null;
  street?: string | null;
  town?: string | null;
  post_code?: string | null;
  website?: string | null;
  primary_color?: string | null;
};
export type AzureResponse601SprengnetterValuationHubApiModelResponseUserProfileResponseRead =
  {
    has_value?: boolean;
    value?: SprengnetterValuationHubApiModelResponseUserProfileResponse | null;
  };
export type SprengnetterValuationHubValuationPackageModelResponseValuationPackageStatusResponse =
  {
    booked_valuations_count?: number;
    remaining_valuations_count?: number;
    expiration_date?: string | null;
    can_view_institution_valuations?: boolean;
    can_create_valuations?: boolean;
    authentication_source?: string | null;
  };
export type SprengnetterSprengConnectApiModelResponseValuationPackageReportUserResponse =
  {
    id?: string | null;
  };
export type SprengnetterSprengConnectApiModelResponseValuationPackageReportResponse =
  {
    user?: SprengnetterSprengConnectApiModelResponseValuationPackageReportUserResponse | null;
    generated_at: string;
    file_name?: string | null;
  };
export type SprengnetterValuationHubValuationPackageModelResponseValuationPackageListItemResponse =
  {
    id: string;
    address: ValuationHubCoreModelRealEstateAddress | null;
    object_type: ValuationHubCoreModelRealEstateEnumsObjectType;
    building_type?: ValuationHubCoreModelRealEstateEnumsBuildingType | null;
    asking_price?: number | null;
    living_area?: number | null;
    valid_until?: string | null;
    reference_number?: string | null;
    created_at: string;
    created_by?: string | null;
  };
export type ValuationHubCoreCommonPaginatedResponse601SprengnetterValuationHubValuationPackageModelResponseValuationPackageListItemResponse =
  {
    data?:
      | SprengnetterValuationHubValuationPackageModelResponseValuationPackageListItemResponse[]
      | null;
    pagination?: ValuationHubCoreCommonMetaPagination | null;
  };
export type SprengnetterValuationHubValuationPackageModelResponseAvmPriceResponse =
  {
    min?: number | null;
    max?: number | null;
    value?: number | null;
    equipment_price_range?:
      | ValuationHubCoreModelRealEstateAvmEquipmentPriceRange[]
      | null;
    selected_equipment_price_range?: ValuationHubCoreModelRealEstateAvmEquipmentPriceRange | null;
  };
export type SprengnetterValuationHubValuationPackageModelResponseSonePriceResponse =
  {
    market_value?: number | null;
  };
export type SprengnetterValuationHubProsaWebModelResponseProsaWebMarketValueResponse =
  {
    value?: number | null;
    rounded_value?: number | null;
  };
export type SprengnetterValuationHubProsaWebModelResponseProsaWebMarketFactorWithConfidenceIntervalResponse =
  {
    value?: number | null;
    ci95_min?: number | null;
    ci95_max?: number | null;
    base_value?: number | null;
    recommended_value?: number | null;
    value_min?: number | null;
    value_max?: number | null;
  };
export type SprengnetterValuationHubProsaWebModelResponseProsaWebMarketFactorWithBaseValueResponse =
  {
    value?: number | null;
    ci95_min?: number | null;
    ci95_max?: number | null;
    base_value?: number | null;
    recommended_value?: number | null;
    value_min?: number | null;
    value_max?: number | null;
  };
export type SprengnetterValuationHubProsaWebModelResponseProsaWebCostApproach =
  {
    value?: number | null;
    preliminary_value?: number | null;
    buildings_asset_value?: number | null;
    exterior_facilities_value?: number | null;
    exterior_facilities_percentage?: number | null;
    market_adjustment?: number | null;
    property_specific_features_value?: number | null;
    market_adjustment_per_m2?: number | null;
    remaining_useful_life?: number | null;
    asset_value_factor?: SprengnetterValuationHubProsaWebModelResponseProsaWebMarketFactorWithConfidenceIntervalResponse | null;
    standard_ground_value?: SprengnetterValuationHubProsaWebModelResponseProsaWebMarketFactorWithBaseValueResponse | null;
  };
export type SprengnetterValuationHubProsaWebModelResponseProsaWebComparableRentResponse =
  {
    value?: number | null;
    ci95_min?: number | null;
    ci95_max?: number | null;
    base_value?: number | null;
    recommended_value?: number | null;
    value_min?: number | null;
    value_max?: number | null;
  };
export type SprengnetterValuationHubProsaWebModelResponseProsaWebIncomeApproachComponent =
  {
    gross_annual_income?: number | null;
    gross_annual_income_percentage?: number | null;
    net_annual_income?: number | null;
    property_yield_rate?: SprengnetterValuationHubProsaWebModelResponseProsaWebMarketFactorWithConfidenceIntervalResponse | null;
    comparable_rent?: SprengnetterValuationHubProsaWebModelResponseProsaWebComparableRentResponse | null;
  };
export type SprengnetterValuationHubProsaWebModelResponseProsaWebIncomeApproach =
  {
    value?: number | null;
    preliminary_value?: number | null;
    gross_annual_income?: number | null;
    land_value?: number | null;
    land_value_interest?: number | null;
    capitalized_value?: number | null;
    market_rental_income?: number | null;
    net_annual_income?: number | null;
    net_building_annual_income?: number | null;
    capitalization_multiplier?: number | null;
    remaining_useful_life?: number | null;
    preliminary_buildings_value?: number | null;
    weight?: number | null;
    market_adjustment?: number | null;
    property_specific_features_value?: number | null;
    market_adjustment_per_m2?: number | null;
    property_yield_rate?: SprengnetterValuationHubProsaWebModelResponseProsaWebMarketFactorWithConfidenceIntervalResponse | null;
    comparable_rent?: SprengnetterValuationHubProsaWebModelResponseProsaWebComparableRentResponse | null;
    weighted_property_rate?: number | null;
    residential?: SprengnetterValuationHubProsaWebModelResponseProsaWebIncomeApproachComponent | null;
    commercial?: SprengnetterValuationHubProsaWebModelResponseProsaWebIncomeApproachComponent | null;
  };
export type SprengnetterValuationHubProsaWebModelResponseProsaWebIncomeApproachRead =
  {
    value?: number | null;
    preliminary_value?: number | null;
    gross_annual_income?: number | null;
    land_value?: number | null;
    land_value_interest?: number | null;
    capitalized_value?: number | null;
    market_rental_income?: number | null;
    net_annual_income?: number | null;
    property_operating_costs?: number | null;
    operating_costs_percentage?: number | null;
    net_building_annual_income?: number | null;
    capitalization_multiplier?: number | null;
    remaining_useful_life?: number | null;
    preliminary_buildings_value?: number | null;
    weight?: number | null;
    market_adjustment?: number | null;
    property_specific_features_value?: number | null;
    market_adjustment_per_m2?: number | null;
    property_yield_rate?: SprengnetterValuationHubProsaWebModelResponseProsaWebMarketFactorWithConfidenceIntervalResponse | null;
    comparable_rent?: SprengnetterValuationHubProsaWebModelResponseProsaWebComparableRentResponse | null;
    weighted_property_rate?: number | null;
    residential?: SprengnetterValuationHubProsaWebModelResponseProsaWebIncomeApproachComponent | null;
    commercial?: SprengnetterValuationHubProsaWebModelResponseProsaWebIncomeApproachComponent | null;
  };
export type SprengnetterValuationHubProsaWebModelResponseProsaWebComparableSalesApproach =
  {
    value?: number | null;
    preliminary_value?: number | null;
    weight?: number | null;
    market_adjustment?: number | null;
    market_adjustment_per_m2?: number | null;
    comparable_price?: SprengnetterValuationHubProsaWebModelResponseProsaWebMarketFactorWithConfidenceIntervalResponse | null;
    standard_ground_value?: SprengnetterValuationHubProsaWebModelResponseProsaWebMarketFactorWithBaseValueResponse | null;
  };
export type SprengnetterValuationHubProsaWebModelResponseProsaWebEditableFactorResponse =
  {
    value?: number | null;
    ci95_min?: number | null;
    ci95_max?: number | null;
    residential?: SprengnetterValuationHubProsaWebModelResponseProsaWebEditableFactorResponse | null;
    commercial?: SprengnetterValuationHubProsaWebModelResponseProsaWebEditableFactorResponse | null;
  };
export type SprengnetterValuationHubProsaWebModelResponseProsaWebEditableFactorWithConfidenceIntervalResponse =
  {
    value?: number | null;
    ci95_min?: number | null;
    ci95_max?: number | null;
    residential?: SprengnetterValuationHubProsaWebModelResponseProsaWebEditableFactorResponse | null;
    commercial?: SprengnetterValuationHubProsaWebModelResponseProsaWebEditableFactorResponse | null;
  };
export type SprengnetterValuationHubProsaWebModelResponseProsaWebFactorsResponse =
  {
    asset_value_factor?: SprengnetterValuationHubProsaWebModelResponseProsaWebEditableFactorWithConfidenceIntervalResponse | null;
    property_yield_rate?: SprengnetterValuationHubProsaWebModelResponseProsaWebEditableFactorResponse | null;
    comparable_price?: SprengnetterValuationHubProsaWebModelResponseProsaWebEditableFactorWithConfidenceIntervalResponse | null;
    comparable_rent?: SprengnetterValuationHubProsaWebModelResponseProsaWebEditableFactorResponse | null;
    standard_ground_value?: SprengnetterValuationHubProsaWebModelResponseProsaWebEditableFactorResponse | null;
    market_adjustment_per_m2?: SprengnetterValuationHubProsaWebModelResponseProsaWebEditableFactorResponse | null;
    building_standard?: SprengnetterValuationHubProsaWebModelResponseProsaWebEditableFactorResponse | null;
    modernization?: SprengnetterValuationHubProsaWebModelResponseProsaWebEditableFactorResponse | null;
  };
export type SprengnetterValuationHubProsaWebModelResponseProsaWebResponse = {
  gross_floor_area?: number | null;
  market_value?: SprengnetterValuationHubProsaWebModelResponseProsaWebMarketValueResponse | null;
  cost_approach?: SprengnetterValuationHubProsaWebModelResponseProsaWebCostApproach | null;
  income_approach?: SprengnetterValuationHubProsaWebModelResponseProsaWebIncomeApproach | null;
  comparable_sales_approach?: SprengnetterValuationHubProsaWebModelResponseProsaWebComparableSalesApproach | null;
  factors?: SprengnetterValuationHubProsaWebModelResponseProsaWebFactorsResponse | null;
};
export type SprengnetterValuationHubProsaWebModelResponseProsaWebResponseRead =
  {
    gross_floor_area?: number | null;
    market_value?: SprengnetterValuationHubProsaWebModelResponseProsaWebMarketValueResponse | null;
    cost_approach?: SprengnetterValuationHubProsaWebModelResponseProsaWebCostApproach | null;
    income_approach?: SprengnetterValuationHubProsaWebModelResponseProsaWebIncomeApproachRead | null;
    comparable_sales_approach?: SprengnetterValuationHubProsaWebModelResponseProsaWebComparableSalesApproach | null;
    factors?: SprengnetterValuationHubProsaWebModelResponseProsaWebFactorsResponse | null;
  };
export type SprengnetterValuationHubValuationPackageModelResponseDemandScoreAvmResponse =
  {
    value?: number;
    demand_score_class?: SprengnetterAvmDemandScoreModelsResponsesDemandScore;
  };
export type SprengnetterValuationHubValuationPackageModelResponseValuationResultResponse =
  {
    avm?: SprengnetterValuationHubValuationPackageModelResponseAvmPriceResponse | null;
    sone?: SprengnetterValuationHubValuationPackageModelResponseSonePriceResponse | null;
    prosa_web?: SprengnetterValuationHubProsaWebModelResponseProsaWebResponse | null;
    demand_score?: SprengnetterValuationHubValuationPackageModelResponseDemandScoreAvmResponse | null;
  };
export type SprengnetterValuationHubValuationPackageModelResponseValuationResultResponseRead =
  {
    avm?: SprengnetterValuationHubValuationPackageModelResponseAvmPriceResponse | null;
    sone?: SprengnetterValuationHubValuationPackageModelResponseSonePriceResponse | null;
    prosa_web?: SprengnetterValuationHubProsaWebModelResponseProsaWebResponseRead | null;
    demand_score?: SprengnetterValuationHubValuationPackageModelResponseDemandScoreAvmResponse | null;
  };
export type SprengnetterValuationHubValuationPackageModelResponseValuationPackageItemResponse =
  {
    id: string;
    real_estate: ValuationHubCoreModelRealEstateValuationHubRealEstate | null;
    valuation_result?: SprengnetterValuationHubValuationPackageModelResponseValuationResultResponse | null;
    report_created_at?: string | null;
    report_asking_price?: number | null;
    reference_number?: string | null;
    valid_until?: string | null;
    created_at: string;
    created_by?: string | null;
  };
export type SprengnetterValuationHubValuationPackageModelResponseValuationPackageItemResponseRead =
  {
    id: string;
    real_estate: ValuationHubCoreModelRealEstateValuationHubRealEstate | null;
    valuation_result?: SprengnetterValuationHubValuationPackageModelResponseValuationResultResponseRead | null;
    report_created_at?: string | null;
    report_asking_price?: number | null;
    reference_number?: string | null;
    valid_until?: string | null;
    created_at: string;
    created_by?: string | null;
  };
export type ValuationHubCoreModelRealEstatePartnerImage = {
  url: string | null;
  title: string | null;
  is_profile_picture?: boolean | null;
};
export type ValuationHubCoreModelRealEstatePartnerValuationHubRealEstate = {
  address: ValuationHubCoreModelRealEstateAddress | null;
  property_information: ValuationHubCoreModelRealEstatePropertyInformation | null;
  financial_information?: ValuationHubCoreModelRealEstateFinancialInformation | null;
  rental_information?: ValuationHubCoreModelRealEstateRentalInformation | null;
  equipment_price_range?:
    | ValuationHubCoreModelRealEstateAvmEquipmentPriceRange[]
    | null;
  selected_equipment_price_range?: ValuationHubCoreModelRealEstateAvmEquipmentPriceRange | null;
  factors?: ValuationHubCoreModelRealEstateProsaWebFactorsInput | null;
  images?: ValuationHubCoreModelRealEstatePartnerImage[] | null;
};
export type ValuationHubCoreModelRealEstateValuationHubRealEstateWithoutAddress =
  {
    property_information: ValuationHubCoreModelRealEstatePropertyInformation | null;
    financial_information?: ValuationHubCoreModelRealEstateFinancialInformation | null;
    rental_information?: ValuationHubCoreModelRealEstateRentalInformation | null;
    selected_equipment_price_range?: ValuationHubCoreModelRealEstateAvmEquipmentPriceRange | null;
    factors?: ValuationHubCoreModelRealEstateProsaWebFactorsInput | null;
  };
export type ValuationHubCoreModelEnumsValuationType =
  | "ALL"
  | "AVM"
  | "SONE"
  | "PROSAWEB";
export type ValuationHubCoreModelDtoValuationReportImageDto = {
  url: string | null;
  title?: string | null;
  is_title_picture?: boolean | null;
};
export type ValuationHubCoreModelDtoContactInformationDto = {
  company_name?: string | null;
  email?: string | null;
  phone_number?: string | null;
  name?: string | null;
  house_number?: string | null;
  street?: string | null;
  town?: string | null;
  post_code?: string | null;
  website?: string | null;
};
export type ValuationHubCoreModelDtoValuationReportConfigurationDto = {
  valuation_type: ValuationHubCoreModelEnumsValuationType;
  title?: string | null;
  reference_number?: string | null;
  real_estate_images?: ValuationHubCoreModelDtoValuationReportImageDto[] | null;
  comments?: string | null;
  company_logo?: string | null;
  company_logo_url?: string | null;
  profile_picture?: string | null;
  profile_picture_url?: string | null;
  primary_color?: string | null;
  contact_information?: ValuationHubCoreModelDtoContactInformationDto | null;
};
export type SprengnetterValuationHubValuationPackageDtoResponsesUploadImageResponse =
  {
    id?: string;
    url?: string | null;
    title?: string | null;
    is_profile_picture?: boolean;
  };
export type ValuationHubCoreModelValuationPackageItemDemandScore = {
  id?: string;
  valuation_package_item_id?: string;
  valuation_package_item?: ValuationHubCoreModelValuationPackageItem | null;
  value?: number;
  demand_score_class?: SprengnetterAvmDemandScoreModelsResponsesDemandScore;
  created_at: string;
};
export type ValuationHubCoreModelValuationPackageItemDemandScoreRead = {
  id?: string;
  valuation_package_item_id?: string;
  valuation_package_item?: ValuationHubCoreModelValuationPackageItem | null;
  value?: number;
  demand_score_class?: SprengnetterAvmDemandScoreModelsResponsesDemandScore;
  created_at: string;
};
export type ValuationHubCoreModelEnumsValuationApiResponseType = 0 | 1 | 2;
export type ValuationHubCoreModelValuationPackageItemApiResponse = {
  id?: string;
  valuation_package_item_id?: string;
  valuation_package_item?: ValuationHubCoreModelValuationPackageItem | null;
  type?: ValuationHubCoreModelEnumsValuationApiResponseType;
  response_json?: string | null;
  created_at: string;
  updated_at?: string | null;
};
export type ValuationHubCoreModelValuationPackageItemApiResponseRead = {
  id?: string;
  valuation_package_item_id?: string;
  valuation_package_item?: ValuationHubCoreModelValuationPackageItem | null;
  type?: ValuationHubCoreModelEnumsValuationApiResponseType;
  response_json?: string | null;
  created_at: string;
  updated_at?: string | null;
};
export type ValuationHubCoreModelValuationPackageItemReport = {
  valuation_package_item_id?: string;
  generated_at: string;
  file_name?: string | null;
  valuation_package_item?: ValuationHubCoreModelValuationPackageItem | null;
};
export type ValuationHubCoreModelValuationPackageItemReportRead = {
  valuation_package_item_id?: string;
  generated_at: string;
  file_name?: string | null;
  valuation_package_item?: ValuationHubCoreModelValuationPackageItem | null;
};
export type ValuationHubCoreModelValuationPackageItem = {
  id?: string;
  institution_id?: number;
  institution?: ValuationHubCoreModelInstitution | null;
  nation?: string | null;
  town?: string | null;
  street?: string | null;
  house_number?: string | null;
  post_code?: string | null;
  lat?: number | null;
  lng?: number | null;
  object_type?: ValuationHubCoreModelRealEstateEnumsObjectType;
  building_type?: ValuationHubCoreModelRealEstateEnumsBuildingType | null;
  real_estate_info?: string | null;
  asking_price?: number | null;
  avm_response?: string | null;
  sone_response?: string | null;
  valid_until?: string | null;
  reference_number?: string | null;
  report_created_at?: string | null;
  report_asking_price?: number | null;
  created_at: string;
  created_by_user_id?: string | null;
  created_by?: ValuationHubCoreModelUser | null;
  demand_score_avm_response?: ValuationHubCoreModelValuationPackageItemDemandScore | null;
  api_responses?: ValuationHubCoreModelValuationPackageItemApiResponse[] | null;
  images?: ValuationHubCoreModelImage[] | null;
  reports?: ValuationHubCoreModelValuationPackageItemReport[] | null;
  external_property_id?: string | null;
};
export type NpgsqlTypesNpgsqlTsVectorLexeme = {
  text?: string | null;
};
export type NpgsqlTypesNpgsqlTsVectorLexemeRead = {
  text?: string | null;
  count?: number;
};
export type ValuationHubCoreModelValuationPackageItemRead = {
  id?: string;
  institution_id?: number;
  institution?: ValuationHubCoreModelInstitutionRead | null;
  nation?: string | null;
  town?: string | null;
  street?: string | null;
  house_number?: string | null;
  post_code?: string | null;
  lat?: number | null;
  lng?: number | null;
  object_type?: ValuationHubCoreModelRealEstateEnumsObjectType;
  building_type?: ValuationHubCoreModelRealEstateEnumsBuildingType | null;
  real_estate_info?: string | null;
  asking_price?: number | null;
  avm_response?: string | null;
  sone_response?: string | null;
  valid_until?: string | null;
  reference_number?: string | null;
  report_created_at?: string | null;
  report_asking_price?: number | null;
  created_at: string;
  created_by_user_id?: string | null;
  created_by?: ValuationHubCoreModelUserRead | null;
  demand_score_avm_response?: ValuationHubCoreModelValuationPackageItemDemandScoreRead | null;
  api_responses?:
    | ValuationHubCoreModelValuationPackageItemApiResponseRead[]
    | null;
  images?: ValuationHubCoreModelImage[] | null;
  reports?: ValuationHubCoreModelValuationPackageItemReportRead[] | null;
  address_search?: NpgsqlTypesNpgsqlTsVectorLexemeRead[] | null;
  address_text?: string | null;
  external_property_id?: string | null;
};
export type ValuationHubCoreModelImage = {
  id?: string;
  url?: string | null;
  title: string | null;
  is_profile_picture?: boolean;
  order?: number;
  valuation_package_item_id?: string;
  valuation_package_item?: ValuationHubCoreModelValuationPackageItem | null;
};
export type ValuationHubCoreModelImageRead = {
  id?: string;
  url?: string | null;
  title: string | null;
  is_profile_picture?: boolean;
  order?: number;
  valuation_package_item_id?: string;
  valuation_package_item?: ValuationHubCoreModelValuationPackageItemRead | null;
};
export type SprengnetterValuationHubValuationPackageDtoRequestsValuationPackageItemImageUpdate =
  {
    id?: string;
    title?: string | null;
    is_profile_picture?: boolean;
  };
export type SprengnetterValuationHubValuationPackageDtoRequestsValuationPackageItemImagesUpdateRequest =
  {
    images?:
      | SprengnetterValuationHubValuationPackageDtoRequestsValuationPackageItemImageUpdate[]
      | null;
  };
export type SprengnetterValuationHubValuationReportModelResponseAvmPriceResponse =
  {
    min?: number | null;
    max?: number | null;
    demand_score?: SprengnetterValuationHubValuationPackageModelResponseDemandScoreAvmResponse | null;
  };
export type SprengnetterValuationHubValuationReportModelResponseValuationReportStatusResponseAvmData =
  {
    timestamp: string;
    price: SprengnetterValuationHubValuationReportModelResponseAvmPriceResponse | null;
  };
export type SprengnetterValuationHubValuationReportModelResponseSonePriceResponse =
  {
    market_value?: number | null;
  };
export type SprengnetterValuationHubValuationReportModelResponseValuationReportStatusResponseSoneData =
  {
    timestamp: string;
    price: SprengnetterValuationHubValuationReportModelResponseSonePriceResponse | null;
  };
export type SprengnetterValuationHubValuationReportModelResponseValuationReportStatusResponseProsaWebData =
  {
    timestamp: string;
    price: SprengnetterValuationHubProsaWebModelResponseProsaWebResponse | null;
  };
export type SprengnetterValuationHubValuationReportModelResponseValuationReportStatusResponseProsaWebDataRead =
  {
    timestamp: string;
    price: SprengnetterValuationHubProsaWebModelResponseProsaWebResponseRead | null;
  };
export type SprengnetterValuationHubValuationReportModelResponseValuationReportStatusResponse =
  {
    report_file_name?: string | null;
    report_timestamp?: string | null;
    report_asking_price?: number | null;
    real_estate_pull_timestamp: string;
    avm?: SprengnetterValuationHubValuationReportModelResponseValuationReportStatusResponseAvmData | null;
    sone?: SprengnetterValuationHubValuationReportModelResponseValuationReportStatusResponseSoneData | null;
    prosa_web?: SprengnetterValuationHubValuationReportModelResponseValuationReportStatusResponseProsaWebData | null;
  };
export type SprengnetterValuationHubValuationReportModelResponseValuationReportStatusResponseRead =
  {
    report_file_name?: string | null;
    report_timestamp?: string | null;
    report_asking_price?: number | null;
    real_estate_pull_timestamp: string;
    avm?: SprengnetterValuationHubValuationReportModelResponseValuationReportStatusResponseAvmData | null;
    sone?: SprengnetterValuationHubValuationReportModelResponseValuationReportStatusResponseSoneData | null;
    prosa_web?: SprengnetterValuationHubValuationReportModelResponseValuationReportStatusResponseProsaWebDataRead | null;
  };
export const {
  usePostServiceApi2BackOfficeAddDocumentMutation,
  useDeleteServiceApi2BackOfficeRemoveDocumentMutation,
  useGetServiceApi2BackOfficeGetAllIndexFeaturesQuery,
  useGetServiceApi2BackOfficeGetAllFeaturesQuery,
  usePutServiceApi2BackOfficeAddFeatureToIndexMutation,
  useDeleteServiceApi2BackOfficeRemoveFeatureFromIndexMutation,
  useGetServiceApi2BackOfficeGetAllIndexesQuery,
  usePostServiceApi2BackOfficeAddIndexMutation,
  usePutServiceApi2BackOfficeUpdateIndexByIdMutation,
  useGetServiceApi2BackOfficeGetInstitutionsPageByNameAndIdQuery,
  useGetServiceApi2BackOfficeGetAllInstitutionsQuery,
  usePostServiceApi2BackOfficeCreateInstitutionMutation,
  usePutServiceApi2BackOfficeUpdateInstitutionMutation,
  useDeleteServiceApi2BackOfficeDeleteInstitutionMutation,
  useGetServiceApi2BackOfficeGetInstitutionsBySubscriptionQuery,
  usePostServiceApi2BackOfficeAddPermissionMutation,
  useDeleteServiceApi2BackOfficeRemovePermissionBySubscriptionIdMutation,
  useGetServiceApi2BackOfficeGetSubscriptionsQuery,
  usePostServiceApi2BackOfficeCreateSubscriptionMutation,
  usePutServiceApi2BackOfficeUpdateSubscriptionMutation,
  useDeleteServiceApi2BackOfficeDeleteSubscriptionMutation,
  useGetServiceApi2BackOfficeGetUnassignedUsersQuery,
  useGetServiceApi2BackOfficeGetUsersByInstitutionQuery,
  usePutServiceApi2BackOfficeAssignUserToInstitutionMutation,
  usePostServiceApi2BackOfficeCreateUserMutation,
  usePostServiceApi2BackOfficeCreateUserWithInstitutionMutation,
  useDeleteServiceApi2BackOfficeDeleteUserMutation,
  usePutServiceApi2BackOfficeUpdateUserMutation,
  usePostServiceApiBackOfficeSendInvitationMutation,
  useGetServiceApi2BackOfficeEncryptQuery,
  useGetServiceApi2BackOfficeDecryptQuery,
  usePostServiceApi2BackOfficeValuationReportReloadAssetsMutation,
  useDeleteServiceApi2BackOfficeRemoveWidgetByIdMutation,
  usePostServiceApiBatchesBatchMutation,
  usePostServiceApiBatchesByUuidProcessedMutation,
  useGetServiceApiBatchesStatusQuery,
  useGetServiceApiBatchesResultQuery,
  useGetServiceApiPingQuery,
  useHeadServiceApiPingMutation,
  usePostServiceApiIndexIpivaluationMutation,
  usePostServiceApiIndexIpirentMutation,
  usePostServiceApiIndexSimMutation,
  usePostServiceApiIndexSipnMutation,
  usePostServiceApiIndexSepiMutation,
  usePostServiceApiIndexValuationAipiMutation,
  usePostServiceApiIndexDemandscoreMutation,
  usePostServiceApiIndexCrr3RiskDiscountMutation,
  useGetServiceApiIndexByIndexDocumentQuery,
  useGetServiceApiInstitutionUsersQuery,
  usePutServiceApiInstitutionProfileSettingsMutation,
  useGetServiceApiInstitutionProfileSettingsQuery,
  usePostServiceApiInstitutionCreateUserMutation,
  useDeleteServiceApiInstitutionDeleteUserMutation,
  usePutServiceApiInstitutionUpdateUserMutation,
  useGetServiceApiOktaHookQuery,
  usePostServiceApiOktaHookMutation,
  usePostServiceApiOktaHookPermissionsMutation,
  usePostServiceApiV2OneclickSoneMutation,
  usePostServiceApiV2OneclickObjectPlatformMutation,
  usePostServiceApiOutlierShieldPlausibilityCheckBySoneValuationIdMutation,
  usePostServiceApiOutlierShieldGetPlausibilityCheckRequestBodyMutation,
  useGetServiceApiProtocolDataInstitutionsQuery,
  useGetServiceApiShopProductsQuery,
  usePostServiceApiShopPurchasesByProductIdMutation,
  usePostExchangeMutation,
  useGetServiceApiUserPermissionsQuery,
  usePutServiceApiUserProfileSettingsMutation,
  useGetServiceApiUserProfileSettingsQuery,
  useGetServiceApiUserProfileQuery,
  useGetServiceApiValuationPackageStatusQuery,
  useGetServiceApiValuationPackageInstitutionReportsQuery,
  useGetServiceApiValuationPackageValuationsQuery,
  usePostServiceApiValuationPackageValuationMutation,
  usePostServiceApiValuationPackageValuationPartnerMutation,
  usePutServiceApiValuationPackageValuationByItemIdMutation,
  useGetServiceApiValuationPackageValuationByItemIdQuery,
  useDeleteServiceApiValuationPackageValuationByItemIdMutation,
  usePostServiceApiValuationPackageValuationByItemIdCopyMutation,
  usePostServiceApiValuationPackageValuationByItemIdValuateMutation,
  usePostServiceApiValuationPackageValuationPartnervaluateMutation,
  usePostServiceApiValuationPackageValuationByItemIdReportPdfMutation,
  useGetServiceApiValuationPackageValuationByItemIdReportPdfQuery,
  usePostServiceApiValuationPackageValuationByItemIdReportDocxMutation,
  useGetServiceApiValuationPackageValuationByItemIdReportDocxQuery,
  usePostServiceApiValuationPackageValuationByValuationPackageItemIdImageMutation,
  usePostServiceApiValuationPackageValuationPartnerByValuationPackageItemIdImagesMutation,
  useDeleteServiceApiValuationPackageValuationImageByIdMutation,
  useGetServiceApiValuationPackageValuationByValuationPackageItemIdImagesQuery,
  usePutServiceApiValuationPackageValuationByValuationPackageItemIdImagesMutation,
  useGetServiceApiValuationReportLoginQuery,
  useGetServiceApiValuationReportLoginCallbackByRealEstateIdQuery,
  useGetServiceApiValuationReportStatusQuery,
  useGetServiceApiValuationReportRealEstateQuery,
  usePutServiceApiValuationReportRealEstateMutation,
  useGetServiceApiValuationReportRealEstateImagesQuery,
  useGetServiceApiValuationReportRealEstateContactQuery,
  useGetServiceApiValuationReportAvmValuateQuery,
  useGetServiceApiValuationReportSoneValuateQuery,
  useGetServiceApiValuationReportProsawebValuateQuery,
  usePostServiceApiValuationReportReportMutation,
  useGetServiceApiValuationReportReportQuery,
  usePostServiceApiSimMutation,
  usePostServiceApiSipnMutation,
} = injectedRtkApi;
